import { combineEpics, ofType } from "redux-observable";
import { concatMap, filter, map, mergeMap, switchMap, withLatestFrom } from "rxjs/operators";
import { EMPTY, from, of } from "rxjs";
import { fetchFinalCalculationData, fetchGasCP1Calculation, fetchGasCP2Calculation, fetchGasCP3Calculation, fetchGasGKXCalculation, fetchGasSP1Calculation, fetchGasSP2Calculation, fetchGasSP3Calculation, fetchGasSP4Calculation, setFinalCalculationData, setGasAnchorID, setGasAnchorOutput, setGasCalculationComplete, setGasIntakeOutput, setGasOutputCP1Data, setGasOutputCP2Data, setGasOutputCP3Data, setGasOutputGKXData, setGasOutputSP1Data, setGasOutputSP2Data, setGasOutputSP3Data, setGasOutputSP4Data, setGasPowerRating, setGasSeparatorList, setGasSeparatorsEquipmentDropdown, setGasTubingODList, setShowHideGasSeparatorEquipment, setTFVSepWarning, setExistedGasSepEquipments, setSepName, setGasNotification, setTypeOfShaft, setTypeOfShaft1, setTypeOfShaft2, setTypeOfShaft3 } from "../../../store/calculation/calculation-output/gasCalculaionSlice";
import { FinalCalculatedData, GasCalculationOutPut, GasSepEfficiencyPayload } from "../../../store/model/calculations/calculation";
import { RootState } from "../../../store/ConfigureStore";
import { getGasCalAnchorID, getGasCalTubingOD, GetGasChPmp1ChangeValues, getGasDataOnDesignChange, getGasEffChangeData, getGasSeparatorEquipments, getGasSepEfficiency, getPowerRating, getSeparatorList, getTFVWarning } from "../../../services/calculations/calculation-output/gasCalculation.service";
import { setHiddenSep1Eff, setHiddenSep2Eff, setHiddenSep3Eff, setHiddenSep4Eff } from "../../../store/calculation/calculation-input/TubingSlice";
import { getGKXCalculations } from "../../../services/calculations/calculation-output/gasHandler.service";
import { convertObjToDropdown } from "../../../utilities/commonUtilities";

const getTubingODList = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("gasCalculation/setGasAnchorOD"),
        withLatestFrom(state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),),
        concatMap(([actionData, basicGasCalculation]) => {
            var anchorOD = basicGasCalculation?.anchorOD;
            return from(getGasCalTubingOD(anchorOD)).pipe(
                map(data => {
                    return setGasTubingODList(data?.AnchorTubingODList)
                }),
            )
        }),
    )
};

const getAnchorID = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("gasCalculation/setGasAnchorOD"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input))
        ),
        concatMap(([actionData, basicGasCalculation, tab1Input]) => {
            var anchorOD = basicGasCalculation?.anchorOD;
            var unitSysVal = tab1Input?.unitSys;
            if (anchorOD && unitSysVal) {
                const payload = {
                    AcnhorOD: anchorOD,
                    UnitSys: unitSysVal?.toString()
                }
                return from(getGasCalAnchorID(payload)).pipe(
                    map(data => setGasAnchorID(data)),
                )
            }
            return EMPTY;
        })
    )

};

const getTFVSepWarning = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "gasCalculation/setSelectedGasSeparator",
            "gasCalculation/setGasSeparatorList",
            "tubing/setHiddenGasAutoEff"
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut))
        ),
        concatMap(([actionData, basicGasCalculation, tab1Input, gasCalculationOutput]) => {
            if (basicGasCalculation?.sepSelcted !== "" && gasCalculationOutput !== null) {
                const noOfGasSeperators = basicGasCalculation?.noOfGasSeps;
                const seperatorType = basicGasCalculation?.sepSelcted;
                const isSeperatorEnabled = Boolean(+(noOfGasSeperators) > 0 && seperatorType?.length);
                var unitSysVal = tab1Input?.unitSys;
                var TFV = 0;

                if (isSeperatorEnabled && +noOfGasSeperators === 4)
                    TFV = gasCalculationOutput?.SP4_TotalFluidVolume;
                else if (isSeperatorEnabled && +noOfGasSeperators === 3)
                    TFV = gasCalculationOutput?.SP3_TotalFluidVolume;
                else if (isSeperatorEnabled && +noOfGasSeperators === 2)
                    TFV = gasCalculationOutput?.SP2_TotalFluidVolume;
                else if (isSeperatorEnabled && +noOfGasSeperators === 1)
                    TFV = gasCalculationOutput?.SP1_TotalFluidVolume;
                const payload = {
                    TFV: TFV,
                    UnitSym: unitSysVal?.toString(),
                    SepVal: seperatorType
                }
                return from(getTFVWarning(payload)).pipe(
                    map(data => setTFVSepWarning(data)),
                )
            }
            return EMPTY;
        })
    )
};

const fetchPowerRating = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("gasCalculation/setSelectedGasSeparator", "gasCalculation/setGasCalculation"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input))
        ),
        switchMap(([actionData, basicGasCalculation, tab1Input]) => {
            var sepType = basicGasCalculation?.sepSelcted;
            var unitSysVal = tab1Input?.unitSys;
            if (sepType && sepType !== '') {
                const payload = {
                    SeparatorID: sepType,
                    UnitSys: unitSysVal
                }
                return from(getPowerRating(payload)).pipe(
                    map(data => setGasPowerRating(data))
                )
            }
            return EMPTY;
        })
    )
};

const gasDesignChange = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "gasCalculation/fetchGasAnchorCalculation",
            "gasCalculation/setNoOfSeparators",
            "gasCalculation/setGasTubingOD",
            "gasCalculation/setSelectedGasSeparator"
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
            state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut?.Intake_NaturalSeperatorEff)),
            state$.pipe(map((state: RootState) => state?.fluid?.region)),
            state$.pipe(map((state: RootState) => state?.fluid?.regionList)),
            state$.pipe(map((state: RootState) => state?.fluid?.selectedRegion))
        ),
        concatMap(([actionData, gasData, tab1Input, tab3Input, tab2Input, intakeNaturalSepEff, region, regionList, selectedRegion]) => {
            const selRegion = regionList?.find((x: any) => x?.id === region);
            let anchorODSeperator = 0;
            let anchorId = 0;
            let anchorTubingOD = 0;
            let intake_NaturalSepEff = intakeNaturalSepEff === undefined ? gasData?.gasIntakeNaturalSeparatorEfficiency : intakeNaturalSepEff ?? 0;

            const BOPD = tab3Input?.bopd;
            const BWPD = tab3Input?.bwpd;
            const bottomHoleTemp = tab3Input?.bottomHoleTemp;
            const casingId = +(tab1Input?.casingID || 0);
            const compSpGr = +tab3Input?.combinedSpGr || 0;
            const liquidCompSpGr = +tab3Input?.liquidPhaseCombinedSpGr || 0;
            let GOR = +tab3Input?.gor;
            let gasCompression = +tab3Input?.gasCompressibility || null;
            const gasDesign = +(gasData?.gasDesign || 0);
            const productionRate = tab2Input?.productionRate;
            const spGrGas = tab3Input?.spGrGas;
            const spGrWater = tab3Input?.spGrWater;
            const spGrOil = tab3Input?.spGrOil;
            const oilAPI = tab3Input?.oilAPI;
            const tubingOD = +tab1Input?.tubingOD;
            const waterCut = tab3Input?.waterCut;
            const BOPDUnit = tab3Input?.unitBOPDListVal;
            const BWPDUnit = tab3Input?.unitBWPDListVal;
            const bottomHoleTempUnit = tab3Input?.unitBottomHoleTempListVal;
            const gasAvailability = tab3Input?.gasAvailblty;
            const GORUnit = +tab3Input?.unitGORListVal;
            const productionRateUnit = +tab2Input?.unitProductionRateListVal;
            const unitSystem = tab1Input?.unitSys;
            const casingPressure = tab2Input?.casingPressure || 0;
            const casingPressureUnit = tab2Input?.unitCasingPressureListVal;
            const flop = tab2Input?.flop || 0; // need to check this value
            const perforation = tab2Input?.perforation;
            const perforationUnit = +tab2Input?.unitPerforationListVal;
            const bubblePressure = tab3Input?.bubblePoint;
            const bubblePressureUnit = tab3Input?.unitBubblePointListVal;
            const pumpSetting = tab2Input?.pumpSetting;
            const pumpSettingUnit = tab2Input?.unitPumpSettingListVal;
            const naturalSepEfficiency = Boolean(+tab1Input?.hiddenGasNatrEffAuto);
            const isGasAvailable = gasAvailability == '1';
            const gasProduction = tab3Input?.gasProduction;
            const gasProductionUnit = tab3Input?.unitGasProductionListVal;
            const casingIDUnit = tab1Input?.unitCasingIDListVal;
            const flopUnit = tab2Input?.unitFLOPListVal;

            if (gasAvailability === '0') {
                GOR = 0;
                gasCompression = 0;
            }

            if (gasDesign === 1) {
                anchorODSeperator = +(gasData?.anchorOD || 0);
                anchorTubingOD = +(gasData?.tubingOD || 0);
                anchorId = +(gasData?.anchorID || 0);
            }
            let regionName = selRegion?.name ?? selectedRegion ?? '';
            const postData: any = [anchorId, anchorODSeperator, anchorTubingOD, BOPD, BWPD, bottomHoleTemp, casingId, compSpGr, GOR, gasDesign, oilAPI, flop, productionRate, spGrGas, spGrOil, spGrWater, tubingOD, waterCut, BOPDUnit, BWPDUnit, bottomHoleTempUnit, GORUnit, productionRateUnit, unitSystem, casingPressure, casingPressureUnit, flop, gasCompression, naturalSepEfficiency, perforation, perforationUnit, bubblePressure, bubblePressureUnit, pumpSetting, pumpSettingUnit, isGasAvailable, gasProduction, gasProductionUnit, casingIDUnit, flopUnit, intake_NaturalSepEff, regionName, liquidCompSpGr];

            return from(getGasDataOnDesignChange(postData)).pipe(
                map(result => {
                    let anchorGasOutput = {} as GasCalculationOutPut;
                    if (gasDesign === 1 && gasData?.tubingOD?.length && gasData?.tubingOD !== '0') {
                        anchorGasOutput = {
                            Anchor_NaturalSeperatorEff: result?.anchor_OP?.naturalSepEff,
                            Anchor_Rs: result?.anchor_OP?.rs,
                            Anchor_Bg: result?.anchor_OP?.bg,
                            Anchor_Bo: result?.anchor_OP?.bo,
                            Anchor_VolumeOfGas: result?.anchor_OP?.gasVolume,
                            Anchor_VolumeOfOil: result?.anchor_OP?.oilVolume,
                            Anchor_VolumeOfWater: result?.anchor_OP?.waterVolume,
                            Anchor_TotalFluidVolume: result?.anchor_OP?.tfv,
                            Anchor_FreeGas: result?.anchor_OP?.freeGas,
                            Anchor_GOR: result?.anchor_OP?.gor,
                            Anchor_GLR: result?.anchor_OP?.glr,
                            Anchor_LiquidPhaseDensity: result?.anchor_OP?.liquidPhaseDensity,
                            Anchor_GasCompressibility: result?.anchor_OP?.gasCompressibility,
                            Anchor_Pressure: result?.anchor_OP?.pip,
                            Anchor_FinalComposite_SpGr: result?.anchor_OP?.compositeSpGr,
                            Anchor_FinalFLOP: result?.anchor_OP?.flop,
                            Anchor_FinalTemperature: result?.anchor_OP?.temperatureOut,
                            Anchor_LiquidPhaseSpGr: result?.anchor_OP?.liquidPhaseSpGr
                        } as GasCalculationOutPut;
                    }

                    var intakeGasOutput = {
                        Intake_NaturalSeperatorEff: result?.intake_OP?.naturalSepEff,
                        Intake_Rs: result?.intake_OP?.rs,
                        Intake_Bo: result?.intake_OP?.bo,
                        Intake_Bg: result?.intake_OP?.bg,
                        Intake_VolumeOfGas: result?.intake_OP?.gasVolume,
                        Intake_VolumeOfOil: result?.intake_OP?.oilVolume,
                        Intake_VolumeOfWater: result?.intake_OP?.waterVolume,
                        Intake_TotalFluidVolume: result?.intake_OP?.tfv,
                        Intake_FreeGas: result?.intake_OP?.freeGas,
                        Intake_GOR: result?.intake_OP?.gor,
                        Intake_GLR: result?.intake_OP?.glr,
                        Intake_LiquidPhaseDensity: result?.intake_OP?.liquidPhaseDensity,
                        Intake_GasCompressibility: result?.intake_OP?.gasCompressibility,
                        Intake_Pressure: result?.intake_OP?.pip,
                        Intake_FinalComposite_SpGr: result?.intake_OP?.compositeSpGr,
                        Intake_FinalFLOP: result?.intake_OP?.flop,
                        Intake_FinalTemperature: result?.intake_OP?.temperatureOut,
                        Intake_LiquidPhaseSpGr: result?.intake_OP?.liquidPhaseSpGr,
                    } as GasCalculationOutPut;
                    var output = {
                        anchorGasOutput,
                        intakeGasOutput,
                    }
                    return output;
                }),
                mergeMap(output => {
                    return [
                        setGasIntakeOutput(output?.intakeGasOutput),
                        setGasAnchorOutput(output?.anchorGasOutput),
                        fetchGasSP1Calculation(),
                    ]
                }),
            )
        })
    )
};

const getGasEffLoop1 = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "gasCalculation/fetchGasSP1Calculation",
            "tubing/setHiddenGasAutoEff"
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
        ),
        concatMap(([actionData, gasData, gasoutput, tab1Input]) => {
            const unitSystem = tab1Input?.unitSys;
            const tfvUnit = tab1Input?.hdnGas_TotalFluidVolume;
            const noOfSeps = gasData?.noOfGasSeps;
            const preGVF = gasoutput?.Intake_FreeGas;
            const preTFV = gasoutput?.Intake_TotalFluidVolume ?? 0;
            const sepType = gasData?.sepSelcted;

            var sep1Eff = tab1Input?.hiddenSep1Eff;
            var hiddenGasAutoEff = tab1Input?.hiddenGasAutoEff ?? '0';

            if (+noOfSeps > 0 && sepType && sepType != '') {
                const payload = {
                    sepID: sepType,
                    GVF: preGVF,
                    TFV: preTFV,
                    UnitSys: unitSystem,
                    TFVUnt: tfvUnit,
                }
                return from(getGasSepEfficiency(payload)).pipe(
                    map(data => {
                        if (hiddenGasAutoEff === '1') {
                            return setHiddenSep1Eff(data);
                        }
                        else if (!sep1Eff) {
                            return setHiddenSep1Eff(data);
                        }

                        return setHiddenSep1Eff(sep1Eff);
                    }),
                )
            }
            return [setHiddenSep1Eff(sep1Eff)];
        })
    )
};

const getGasSepData = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("tubing/setHiddenSep1Eff"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
        ),
        concatMap(([actionData, gasData, gasoutput, tab1Input, tab2Input, tab3Input]) => {

            const noOfSeps = gasData?.noOfGasSeps;
            if (+noOfSeps > 0) {
                const sepEffIp = tab1Input?.hiddenSep1Eff;
                const BOPD = tab3Input?.bopd?.toString();
                const bottmWhole = tab3Input?.bottomHoleTemp?.toString();
                const gasVolIngstd = isNaN(gasoutput?.Intake_VolumeOfGas) ? "" : gasoutput?.Intake_VolumeOfGas || "0";
                let liqVolRate = null;
                const oilApi = tab3Input?.oilAPI;
                const PIP = gasoutput?.Intake_Pressure;
                const preFreeGas = gasoutput?.Intake_FreeGas || "0";
                const preGVF = gasoutput?.Intake_FreeGas || "0";
                const preTFV = gasoutput?.Intake_TotalFluidVolume || "0";
                const prodRate = tab2Input?.productionRate || 0;
                const spGrGas = tab3Input?.spGrGas;
                const spGrOil = tab3Input?.spGrOil;
                const spGrWatr = tab3Input?.spGrWater;
                const watrCut = tab3Input?.waterCut;
                const bopdUnit = tab3Input?.unitBOPDListVal || "0";
                const bottmWholeUnit = tab3Input?.unitBottomHoleTempListVal || "0";
                const prodctnRateUnit = tab2Input?.unitProductionRateListVal || "0";
                const unitSys = tab1Input?.unitSys?.toString() || "0";
                const oilVolme = gasoutput?.Intake_VolumeOfOil || "0";
                const watrVolme = gasoutput?.Intake_VolumeOfWater || "0";
                const casingPres = tab2Input?.casingPressure || 0;
                const casingPresUnit = tab2Input?.unitCasingPressureListVal || "0";
                const FLOP = (gasoutput?.Intake_FinalFLOP || 0) > 0 ? gasoutput?.Intake_FinalFLOP : 0;
                let GasComprs = tab3Input?.gasCompressibility;
                let GOR = gasoutput?.Intake_GOR || "0";
                const gasAvail = tab3Input?.gasAvailblty;
                if (gasAvail == '0') {
                    GasComprs = 0;
                    GOR = 0;
                }
                const GORUnit = tab3Input?.unitGORListVal || "0";
                const perfrtn = tab2Input?.perforation || 0;
                const perfrtnUnit = tab2Input?.unitPerforationListVal || "0";
                const bubbPres = tab3Input?.bubblePoint;
                const bubbPresUnit = tab3Input?.unitBubblePointListVal || "0";
                const combSpGr = gasoutput?.Intake_FinalComposite_SpGr || "0";
                const pmpSetng = tab2Input?.pumpSetting || "0";
                const pmpSetngUnit = tab2Input?.unitPumpSettingListVal || "0";
                const GasAvail = tab3Input?.gasAvailblty;
                const BWPD = tab3Input?.bwpd;
                const BWPDUnit = tab3Input?.unitBWPDListVal || "0";
                const BG = gasoutput?.Intake_Bg || "0";
                const isGasVAl = Boolean(GasAvail);

                const gasIPArray: any = [BOPD, bottmWhole, gasVolIngstd, liqVolRate, oilApi, PIP, preFreeGas, preGVF, preTFV, prodRate, spGrGas, spGrOil, spGrWatr, watrCut, bopdUnit, bottmWholeUnit, prodctnRateUnit, unitSys, casingPres, casingPresUnit, FLOP, GasComprs, oilVolme, perfrtn, perfrtnUnit, pmpSetng, pmpSetngUnit, watrVolme, bubbPres, bubbPresUnit, combSpGr, GOR, GORUnit, isGasVAl, BWPD, BWPDUnit, BG];
                const payload = {
                    GasEff: sepEffIp,
                    GasSepIPVals: gasIPArray,
                }
                return from(getGasEffChangeData(payload)).pipe(
                    map(data => {
                        var sp1GasOutput = {
                            SP1_Rs: data?.rs,
                            SP1_Bg: data?.bg,
                            SP1_Bo: data?.bo,
                            SP1_VolumeOfGas: data?.sepGasVolume,
                            SP1_VolumeOfOil: data?.sepOilVolume,
                            SP1_VolumeOfWater: data?.sepWaterVolume,
                            SP1_TotalFluidVolume: data?.sepTFV,
                            SP1_FreeGas: data?.sepFreeGas,
                            SP1_GOR: data?.sepGOR,
                            SP1_GLR: data?.sepGLR,
                            SP1_GVF: data?.sepGVF,
                            SP1_LiquidPhaseDensity: data?.liquidPhaseDensity,
                            SP1_GasCompressibility: data?.gasCompressibility,
                            SP1_Pressure: data?.pip,
                            SP1_FinalComposite_SpGr: data?.compositeSpGr,
                            SP1_FinalFLOP: data?.flop,
                            SP1_FinalTemperature: data?.temperatureOut,
                            SP1_LiquidPhaseSpGr: data?.liquidPhaseSpGr
                        } as GasCalculationOutPut;
                        return sp1GasOutput;
                    }),
                    mergeMap(sp1GasOutput => [
                        setGasOutputSP1Data(sp1GasOutput),
                        fetchGasSP2Calculation(),
                    ])
                )
            }
            return [fetchGasSP2Calculation()];
        }),
    )
};

const getGasEffLoop2 = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("gasCalculation/fetchGasSP2Calculation"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
        ),
        concatMap(([actionData, gasData, gasoutput, tab1Input]) => {
            const unitSystem = tab1Input?.unitSys;
            const tfvUnit = tab1Input?.hdnGas_TotalFluidVolume;
            const noOfSeps = gasData?.noOfGasSeps;
            const preGVF = gasoutput?.SP1_FreeGas;
            const preTFV = gasoutput?.SP1_TotalFluidVolume ?? 0;
            const sepType = gasData?.sepSelcted;

            var sep2Eff = tab1Input?.hiddenSep2Eff

            if (+noOfSeps > 1 && sepType && sepType != '') {
                const payload = {
                    sepID: sepType,
                    GVF: preGVF,
                    TFV: preTFV,
                    UnitSys: unitSystem,
                    TFVUnt: tfvUnit,
                } as GasSepEfficiencyPayload;
                return from(getGasSepEfficiency(payload)).pipe(
                    map(data => {
                        var hiddenGasAutoEff = tab1Input?.hiddenGasAutoEff ?? '0';

                        if (hiddenGasAutoEff === '1') {
                            return setHiddenSep2Eff(data);
                        }
                        else if (!sep2Eff) {
                            return setHiddenSep2Eff(data);
                        }

                        return setHiddenSep2Eff(sep2Eff);
                    }),
                )
            }
            return [setHiddenSep2Eff(sep2Eff)];
        }),
    )
};

const getGasSep2Data = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("tubing/setHiddenSep2Eff"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input))
        ),
        concatMap(([actionData, gasData, gasoutput, tab1Input, tab2Input, tab3Input]) => {
            const noOfSeps = gasData?.noOfGasSeps;

            if (+noOfSeps > 1) {
                const sepEffIp = tab1Input?.hiddenSep2Eff
                const BOPD = tab3Input?.bopd?.toString();
                const bottmWhole = tab3Input?.bottomHoleTemp?.toString();
                const gasVolIngstd = gasoutput?.SP1_VolumeOfGas;
                let liqVolRate = null;
                const oilApi = tab3Input?.oilAPI;
                const PIP = gasoutput?.SP1_Pressure;
                const preFreeGas = gasoutput?.SP1_FreeGas;
                const preGVF = gasoutput?.SP1_FreeGas;
                const preTFV = gasoutput?.SP1_TotalFluidVolume;
                const GOR = gasoutput?.SP1_GOR;
                const GORUnit = tab3Input?.unitGORListVal || "0";
                const prodRate = tab2Input?.productionRate || 0;
                const spGrGas = tab3Input?.spGrGas;
                const spGrOil = tab3Input?.spGrOil;
                const spGrWatr = tab3Input?.spGrWater;
                const watrCut = tab3Input?.waterCut;
                const bopdUnit = tab3Input?.unitBOPDListVal || "0";
                const bottmWholeUnit = tab3Input?.unitBottomHoleTempListVal || "0";
                const prodctnRateUnit = tab2Input?.unitProductionRateListVal || "0";
                const unitSys = tab1Input?.unitSys || "0";
                const oilVolme = gasoutput?.SP1_VolumeOfOil;
                const watrVolme = gasoutput?.SP1_VolumeOfWater;
                const FLOP = gasoutput?.SP1_FinalFLOP;
                const GasComprs = tab3Input?.gasCompressibility;
                const casingPres = tab2Input?.casingPressure || 0;
                const casingPresUnit = tab2Input?.unitCasingPressureListVal || "0";
                const perfrtn = tab2Input?.perforation || 0;
                const perfrtnUnit = tab2Input?.unitPerforationListVal || "0";
                const bubbPres = tab3Input?.bubblePoint || "0";
                const bubbPresUnit = tab3Input?.unitBubblePointListVal || "0";
                const pmpSetng = tab2Input?.pumpSetting || 0;
                const pmpSetngUnit = tab2Input?.unitPumpSettingListVal || "0";
                const BWPD = tab3Input?.bwpd || "0";
                const BWPDUnit = tab3Input?.unitBWPDListVal || "0";
                const combSpGr = gasoutput?.SP1_FinalComposite_SpGr;
                const BG = gasoutput?.SP1_Bg;
                const isGasVAl = Boolean(+tab3Input?.gasAvailblty);

                const gasIPArray = [BOPD, bottmWhole, gasVolIngstd, liqVolRate, oilApi, PIP, preFreeGas, preGVF, preTFV, prodRate, spGrGas, spGrOil, spGrWatr, watrCut, bopdUnit, bottmWholeUnit, prodctnRateUnit, unitSys, casingPres, casingPresUnit, FLOP, GasComprs, oilVolme, perfrtn, perfrtnUnit, pmpSetng, pmpSetngUnit, watrVolme, bubbPres, bubbPresUnit, combSpGr, GOR, GORUnit, isGasVAl, BWPD, BWPDUnit, BG];
                const payload = {
                    GasEff: sepEffIp || 0,
                    GasSepIPVals: gasIPArray,
                }
                return from(getGasEffChangeData(payload)).pipe(
                    map(data => {
                        var sp2GasOutput = {
                            SP2_Rs: data?.rs,
                            SP2_Bg: data?.bg,
                            SP2_Bo: data?.bo,
                            SP2_VolumeOfGas: data?.sepGasVolume,
                            SP2_VolumeOfOil: data?.sepOilVolume,
                            SP2_VolumeOfWater: data?.sepWaterVolume,
                            SP2_TotalFluidVolume: data?.sepTFV,
                            SP2_FreeGas: data?.sepFreeGas,
                            SP2_GOR: data?.sepGOR,
                            SP2_GLR: data?.sepGLR,
                            SP2_GVF: data?.sepGVF,
                            SP2_LiquidPhaseDensity: data?.liquidPhaseDensity,
                            SP2_GasCompressibility: data?.gasCompressibility,
                            SP2_Pressure: data?.pip,
                            SP2_FinalComposite_SpGr: data?.compositeSpGr,
                            SP2_FinalFLOP: data?.flop,
                            SP2_FinalTemperature: data?.temperatureOut,
                            SP2_LiquidPhaseSpGr: data?.liquidPhaseSpGr
                        } as GasCalculationOutPut;
                        return sp2GasOutput;
                    }),
                    mergeMap(sp2GasOutput => [
                        setGasOutputSP2Data(sp2GasOutput),
                        fetchGasSP3Calculation(),
                    ])
                )
            }
            return [fetchGasSP3Calculation()];
        }),
    )
};

const getGasEffLoop3 = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("gasCalculation/fetchGasSP3Calculation"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
        ),
        concatMap(([actionData, gasData, gasoutput, tab1Input]) => {
            const unitSystem = tab1Input?.unitSys;
            const tfvUnit = tab1Input?.hdnGas_TotalFluidVolume;
            const noOfSeps = gasData?.noOfGasSeps;
            const preGVF = gasoutput?.SP2_FreeGas;
            const preTFV = gasoutput?.SP2_TotalFluidVolume ?? 0;
            const sepType = gasData?.sepSelcted;

            var sep3Eff = tab1Input?.hiddenSep3Eff;

            if (+noOfSeps > 2 && sepType && sepType != '') {
                const payload = {
                    sepID: sepType,
                    GVF: preGVF,
                    TFV: preTFV,
                    UnitSys: unitSystem,
                    TFVUnt: tfvUnit,
                }
                return from(getGasSepEfficiency(payload)).pipe(
                    map(data => {
                        var hiddenGasAutoEff = tab1Input?.hiddenGasAutoEff ?? '0';

                        if (hiddenGasAutoEff == '1') {
                            return setHiddenSep3Eff(data);
                        }
                        else if (!sep3Eff) {
                            return setHiddenSep3Eff(data);
                        }

                        return setHiddenSep3Eff(sep3Eff);
                    }),
                )
            }
            return [setHiddenSep3Eff(sep3Eff)];
        }),
    )
};

const getGasSep3Data = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("tubing/setHiddenSep3Eff"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
        ),
        concatMap(([actionData, gasData, gasoutput, tab1Input, tab2Input, tab3Input]) => {

            const noOfSeps = gasData?.noOfGasSeps
            if (+noOfSeps > 2) {
                const sepEffIp = +tab1Input?.hiddenSep3Eff;
                const BOPD = tab3Input?.bopd?.toString();
                const bottmWhole = tab3Input?.bottomHoleTemp?.toString();
                const gasVolIngstd = gasoutput?.SP2_VolumeOfGas;
                let liqVolRate = null;
                const oilApi = tab3Input?.oilAPI;
                const PIP = gasoutput?.SP2_Pressure;
                const preFreeGas = gasoutput?.SP2_FreeGas;
                const preGVF = gasoutput?.SP2_FreeGas;
                const preTFV = gasoutput?.SP2_TotalFluidVolume;
                const GOR = gasoutput?.SP2_GOR;
                const GORUnit = tab3Input?.unitGORListVal || "0";
                const prodRate = tab2Input?.productionRate || 0;
                const spGrGas = tab3Input?.spGrGas;
                const spGrOil = tab3Input?.spGrOil;
                const spGrWatr = tab3Input?.spGrWater;
                const watrCut = tab3Input?.waterCut;
                const bopdUnit = tab3Input?.unitBOPDListVal || "0";
                const bottmWholeUnit = tab3Input?.unitBottomHoleTempListVal || "0";
                const prodctnRateUnit = tab2Input?.unitProductionRateListVal || "0";
                const unitSys = tab1Input?.unitSys || "0";
                const oilVolme = gasoutput?.SP2_VolumeOfOil;
                const watrVolme = gasoutput?.SP2_VolumeOfWater;
                const FLOP = gasoutput?.SP2_FinalFLOP;
                const GasComprs = tab3Input?.gasCompressibility;
                const casingPres = tab2Input?.casingPressure || 0;
                const casingPresUnit = tab2Input?.unitCasingPressureListVal || "0";
                const gasAvail = tab3Input?.gasAvailblty;
                const perfrtn = tab2Input?.perforation || 0;
                const perfrtnUnit = tab2Input?.unitPerforationListVal || "0";
                const bubbPres = tab3Input?.bubblePoint || "0";
                const bubbPresUnit = tab3Input?.unitBubblePointListVal || "0";
                const pmpSetng = tab2Input?.pumpSetting || 0;
                const pmpSetngUnit = tab2Input?.unitPumpSettingListVal || "0";
                const GasAvail = tab3Input?.gasAvailblty || "0";
                const BWPD = tab3Input?.bwpd || "0";
                const BWPDUnit = tab3Input?.unitBWPDListVal || "0";
                const combSpGr = gasoutput?.SP2_FinalComposite_SpGr;
                const BG = gasoutput?.SP2_Bg;
                const isGasVAl = Boolean(+tab3Input?.gasAvailblty);

                const gasIPArray = [BOPD, bottmWhole, gasVolIngstd, liqVolRate, oilApi, PIP, preFreeGas, preGVF, preTFV, prodRate, spGrGas, spGrOil, spGrWatr, watrCut, bopdUnit, bottmWholeUnit, prodctnRateUnit, unitSys, casingPres, casingPresUnit, FLOP, GasComprs, oilVolme, perfrtn, perfrtnUnit, pmpSetng, pmpSetngUnit, watrVolme, bubbPres, bubbPresUnit, combSpGr, GOR, GORUnit, isGasVAl, BWPD, BWPDUnit, BG];
                const payload = {
                    GasEff: sepEffIp || 0,
                    GasSepIPVals: gasIPArray,
                }
                return from(getGasEffChangeData(payload)).pipe(
                    map(data => {
                        var sp3GasOutput = {
                            SP3_Rs: data?.rs,
                            SP3_Bg: data?.bg,
                            SP3_Bo: data?.bo,
                            SP3_VolumeOfGas: data?.sepGasVolume,
                            SP3_VolumeOfOil: data?.sepOilVolume,
                            SP3_VolumeOfWater: data?.sepWaterVolume,
                            SP3_TotalFluidVolume: data?.sepTFV,
                            SP3_FreeGas: data?.sepFreeGas,
                            SP3_GOR: data?.sepGOR,
                            SP3_GLR: data?.sepGLR,
                            SP3_GVF: data?.sepGVF,
                            SP3_LiquidPhaseDensity: data?.liquidPhaseDensity,
                            SP3_GasCompressibility: data?.gasCompressibility,
                            SP3_Pressure: data?.pip,
                            SP3_FinalComposite_SpGr: data?.compositeSpGr,
                            SP3_FinalFLOP: data?.flop,
                            SP3_FinalTemperature: data?.temperatureOut,
                            SP3_LiquidPhaseSpGr: data?.liquidPhaseSpGr
                        } as GasCalculationOutPut;
                        return sp3GasOutput
                    }),
                    mergeMap(sp3GasOutput => [
                        setGasOutputSP3Data(sp3GasOutput),
                        fetchGasSP4Calculation(),
                    ])
                )
            }
            return [fetchGasSP4Calculation()];
        }),
    )
};

const getGasEffLoop4 = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("gasCalculation/fetchGasSP4Calculation"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
        ),
        concatMap(([actionData, gasData, gasoutput, tab1Input]) => {
            const unitSystem = tab1Input?.unitSys
            const tfvUnit = tab1Input?.hdnGas_TotalFluidVolume
            const noOfSeps = gasData?.noOfGasSeps
            const preGVF = gasoutput?.SP3_FreeGas
            const preTFV = gasoutput?.SP3_TotalFluidVolume ?? 0
            const sepType = gasData?.sepSelcted;

            var sep4Eff = tab1Input?.hiddenSep4Eff;

            if (+noOfSeps > 3 && sepType && sepType != '') {
                const payload = {
                    sepID: sepType,
                    GVF: preGVF,
                    TFV: preTFV,
                    UnitSys: unitSystem,
                    TFVUnt: tfvUnit,
                }
                return from(getGasSepEfficiency(payload)).pipe(
                    map(data => {
                        var hiddenGasAutoEff = tab1Input?.hiddenGasAutoEff ?? '0';

                        if (hiddenGasAutoEff == '1') {
                            return setHiddenSep4Eff(data);
                        }
                        else if (!sep4Eff) {
                            return setHiddenSep4Eff(data);
                        }

                        return setHiddenSep4Eff(sep4Eff);
                    }),
                )
            }
            return [setHiddenSep4Eff(sep4Eff)];
        }),
    )
};

const getGasSep4Data = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("tubing/setHiddenSep4Eff"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
        ),
        concatMap(([actionData, gasData, gasoutput, tab1Input, tab2Input, tab3Input]) => {

            const noOfSeps = gasData?.noOfGasSeps;
            if (+noOfSeps > 3) {
                const unitSys = tab1Input?.unitSys || "0";
                const sepEffIp = +tab1Input?.hiddenSep4Eff;
                const casingPres = tab2Input?.casingPressure || 0;
                const perfrtn = tab2Input?.perforation || 0;
                const prodRate = tab2Input?.productionRate || 0;
                const pmpSetng = tab2Input?.pumpSetting || 0;
                const BOPD = tab3Input?.bopd?.toString();
                const BWPD = tab3Input?.bwpd || "0";
                const oilApi = tab3Input?.oilAPI;
                const spGrGas = tab3Input?.spGrGas;
                const spGrOil = tab3Input?.spGrOil;
                const spGrWatr = tab3Input?.spGrWater;
                const watrCut = tab3Input?.waterCut;
                const bottmWhole = tab3Input?.bottomHoleTemp?.toString();
                const GasComprs = tab3Input?.gasCompressibility;
                const bubbPres = tab3Input?.bubblePoint || "0";
                const isGasVAl = +tab3Input?.gasAvailblty;
                const gasVolIngstd = gasoutput?.SP3_VolumeOfGas;
                let liqVolRate = null;
                const PIP = gasoutput?.SP3_Pressure;
                const preFreeGas = gasoutput?.SP3_FreeGas;
                const preGVF = gasoutput?.SP3_FreeGas;
                const preTFV = gasoutput?.SP3_TotalFluidVolume;
                const GOR = gasoutput?.SP3_GOR;
                const oilVolme = gasoutput?.SP3_VolumeOfOil;
                const watrVolme = gasoutput?.SP3_VolumeOfWater;
                const FLOP = gasoutput?.SP3_FinalFLOP;
                const combSpGr = gasoutput?.SP3_FinalComposite_SpGr;
                const BG = gasoutput?.SP3_Bg;
                const casingPresUnit = tab2Input?.unitCasingPressureListVal || "0";
                const perfrtnUnit = tab2Input?.unitPerforationListVal || "0";
                const bubbPresUnit = tab3Input?.unitBubblePointListVal || "0";
                const pmpSetngUnit = tab2Input?.unitPumpSettingListVal || "0";
                const GORUnit = tab3Input?.unitGORListVal || "0";
                const bopdUnit = tab3Input?.unitBOPDListVal || "0";
                const BWPDUnit = tab3Input?.unitBWPDListVal || "0";
                const bottmWholeUnit = tab3Input?.unitBottomHoleTempListVal || "0";
                const prodctnRateUnit = tab2Input?.unitProductionRateListVal || "0";
                const gasIPArray = [BOPD, bottmWhole, gasVolIngstd, liqVolRate, oilApi, PIP, preFreeGas, preGVF, preTFV, prodRate, spGrGas, spGrOil, spGrWatr, watrCut, bopdUnit, bottmWholeUnit, prodctnRateUnit, unitSys, casingPres, casingPresUnit, FLOP, GasComprs, oilVolme, perfrtn, perfrtnUnit, pmpSetng, pmpSetngUnit, watrVolme, bubbPres, bubbPresUnit, combSpGr, GOR, GORUnit, isGasVAl, BWPD, BWPDUnit, BG];
                const payload = {
                    GasEff: sepEffIp || 0,
                    GasSepIPVals: gasIPArray,
                }
                return from(getGasEffChangeData(payload)).pipe(
                    map(data => {
                        var sp4GasOutput = {
                            SP4_Rs: data?.rs,
                            SP4_Bg: data?.bg,
                            SP4_Bo: data?.bo,
                            SP4_VolumeOfGas: data?.sepGasVolume,
                            SP4_VolumeOfOil: data?.sepOilVolume,
                            SP4_VolumeOfWater: data?.sepWaterVolume,
                            SP4_TotalFluidVolume: data?.sepTFV,
                            SP4_FreeGas: data?.sepFreeGas,
                            SP4_GOR: data?.sepGOR,
                            SP4_GLR: data?.sepGLR,
                            SP4_GVF: data?.sepGVF,
                            SP4_LiquidPhaseDensity: data?.liquidPhaseDensity,
                            SP4_GasCompressibility: data?.gasCompressibility,
                            SP4_Pressure: data?.pip,
                            SP4_FinalComposite_SpGr: data?.compositeSpGr,
                            SP4_FinalFLOP: data?.flop,
                            SP4_FinalTemperature: data?.temperatureOut,
                            SP4_LiquidPhaseSpGr: data?.liquidPhaseSpGr,
                        } as GasCalculationOutPut;
                        return sp4GasOutput;
                    }),
                    mergeMap(sp4GasOutput => [
                        setGasOutputSP4Data(sp4GasOutput),
                        fetchGasGKXCalculation(),
                    ])
                )
            }
            return [fetchGasGKXCalculation()];
        }),
    )
};

const getGKXData = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "gasCalculation/setGasGKXCorrectionFactors",
            "gasCalculation/fetchGasGKXCalculation",
            "gasCalculation/setUseGasHandler",
            "gasCalculation/setGasHandler"
        ),

        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.region)),
            state$.pipe(map((state: RootState) => state?.fluid?.regionList)),
            state$.pipe(map((state: RootState) => state?.fluid?.selectedRegion)),
        ),
        concatMap(([actionData, gasDetails, gasoutput, tab1Input, tab2Input, tab3Input, region, regionList, selectedRegion]) => {
            const selRegion = regionList?.find((x: any) => x?.id === region);
            const useOfGKX = gasDetails?.useOfChgPmp;
            if (useOfGKX === '1' && gasDetails?.chargePumpGKX?.length) {
                let GOR = 0; let TFV = 0; let gasVolume = 0; let oilVolume = 0; let waterVolume = 0; let finPIP = 0; let temperature = 0; let flop = 0; let combSpGr = 0; let bg = 0; let freeGas = 0;
                const noOfGasSeperators = gasDetails?.noOfGasSeps
                const seperatorType = gasDetails?.sepSelcted
                const isSeperatorEnabled = Boolean(+(noOfGasSeperators) > 0 && seperatorType?.length)
                if (useOfGKX !== '1' || gasDetails?.chargePumpGKX === "") {
                    return [fetchGasCP1Calculation()];
                }
                if (isSeperatorEnabled && +noOfGasSeperators === 4) {
                    if (gasoutput?.SP4_GOR === undefined) {
                        return [fetchGasCP1Calculation()];
                    }
                    GOR = gasoutput?.SP4_GOR || 0;
                    TFV = gasoutput?.SP4_TotalFluidVolume || 0;
                    gasVolume = gasoutput?.SP4_VolumeOfGas || 0;
                    oilVolume = gasoutput?.SP4_VolumeOfOil || 0;
                    waterVolume = gasoutput?.SP4_VolumeOfWater || 0;
                    freeGas = gasoutput?.SP4_FreeGas || 0;
                    finPIP = gasoutput?.SP4_Pressure || 0;
                    combSpGr = gasoutput?.SP4_FinalComposite_SpGr || 0;
                    temperature = gasoutput?.SP4_FinalTemperature || 0;
                    flop = gasoutput?.SP4_FinalFLOP || 0;
                    bg = gasoutput?.SP4_Bg || 0;
                } else if (isSeperatorEnabled && +noOfGasSeperators === 3) {
                    if (gasoutput?.SP3_GOR === undefined)
                        return EMPTY

                    GOR = gasoutput?.SP3_GOR || 0;
                    TFV = gasoutput?.SP3_TotalFluidVolume || 0;
                    gasVolume = gasoutput?.SP3_VolumeOfGas || 0;
                    oilVolume = gasoutput?.SP3_VolumeOfOil || 0;
                    waterVolume = gasoutput?.SP3_VolumeOfWater || 0;
                    freeGas = gasoutput?.SP3_FreeGas || 0;
                    finPIP = gasoutput?.SP3_Pressure || 0;
                    combSpGr = gasoutput?.SP3_FinalComposite_SpGr || 0;
                    temperature = gasoutput?.SP3_FinalTemperature || 0;
                    flop = gasoutput?.SP3_FinalFLOP || 0;
                    bg = gasoutput?.SP3_Bg || 0;
                } else if (isSeperatorEnabled && +noOfGasSeperators === 2) {

                    if (gasoutput?.SP2_GOR === undefined)
                        return EMPTY;

                    GOR = gasoutput?.SP2_GOR || 0;
                    TFV = gasoutput?.SP2_TotalFluidVolume || 0;
                    gasVolume = gasoutput?.SP2_VolumeOfGas || 0;
                    oilVolume = gasoutput?.SP2_VolumeOfOil || 0;
                    waterVolume = gasoutput?.SP2_VolumeOfWater || 0;
                    freeGas = gasoutput?.SP2_FreeGas || 0;
                    finPIP = gasoutput?.SP2_Pressure || 0;
                    combSpGr = gasoutput?.SP2_FinalComposite_SpGr || 0;
                    temperature = gasoutput?.SP2_FinalTemperature || 0;
                    flop = gasoutput?.SP2_FinalFLOP || 0;
                    bg = gasoutput?.SP2_Bg || 0;
                } else if (isSeperatorEnabled && +noOfGasSeperators === 1) {
                    if (gasoutput?.SP1_GOR === undefined)
                        return EMPTY;

                    GOR = gasoutput?.SP1_GOR || 0;
                    TFV = gasoutput?.SP1_TotalFluidVolume || 0;
                    gasVolume = gasoutput?.SP1_VolumeOfGas || 0;
                    oilVolume = gasoutput?.SP1_VolumeOfOil || 0;
                    waterVolume = gasoutput?.SP1_VolumeOfWater || 0;
                    freeGas = gasoutput?.SP1_FreeGas || 0;
                    finPIP = gasoutput?.SP1_Pressure || 0;
                    combSpGr = gasoutput?.SP1_FinalComposite_SpGr || 0;
                    temperature = gasoutput?.SP1_FinalTemperature || 0;
                    flop = gasoutput?.SP1_FinalFLOP || 0;
                    bg = gasoutput?.SP1_Bg || 0;
                } else {
                    GOR = gasoutput?.Intake_GOR || 0;
                    TFV = gasoutput?.Intake_TotalFluidVolume || 0;
                    gasVolume = gasoutput?.Intake_VolumeOfGas || 0;
                    oilVolume = gasoutput?.Intake_VolumeOfOil || 0;
                    waterVolume = gasoutput?.Intake_VolumeOfWater || 0;
                    freeGas = gasoutput?.Intake_FreeGas || 0;
                    finPIP = gasoutput?.Intake_Pressure || 0;
                    combSpGr = gasoutput?.Intake_FinalComposite_SpGr || 0;
                    temperature = gasoutput?.Intake_FinalTemperature || 0;
                    flop = gasoutput?.Intake_FinalFLOP || 0;
                    bg = gasoutput?.Intake_Bg || 0;
                }

                const postData_Obj = {
                    UnitSystem: +tab1Input?.unitSys || 0,
                    CasingPressure: +tab2Input?.casingPressure || 0,
                    CasingPressureUnit: +tab2Input?.unitCasingPressureListVal || 0,
                    ProductionRate: +tab2Input?.productionRate || 0,
                    ProductionRateUnit: +tab2Input?.unitProductionRateListVal || 0,
                    PumpSetting: +tab2Input?.pumpSetting || 0,
                    PumpSettingUnit: +tab2Input?.unitPumpSettingListVal || 0,
                    Perforation: +tab2Input?.perforation || 0,
                    PerforationUnit: +tab2Input?.unitPerforationListVal || 0,
                    SpGrWater: +tab3Input?.spGrWater || 0,
                    WaterCut: +tab3Input?.waterCut || 0,
                    BWPD: +tab3Input?.bwpd || 0,
                    BWPDUnit: +tab3Input?.unitBWPDListVal || 0,
                    OilAPI: +tab3Input?.oilAPI || 0,
                    SpGrOil: +tab3Input?.spGrOil || 0,
                    BOPD: +tab3Input?.bopd || 0,
                    BOPDUnit: +tab3Input?.unitBOPDListVal || 0,
                    FluidViscosity: +tab3Input?.fluidViscosity || 0,
                    FluidViscosity_Unit: +tab3Input?.unitFluidViscosityListVal || 0,
                    IsGas: tab3Input?.gasAvailblty == "1" ? true : false,
                    GORUnit: +tab3Input?.unitGORListVal || 0,
                    SpGrGas: +tab3Input?.spGrGas || 0,
                    GasCompressibility: +tab3Input?.gasCompressibility || 0,
                    bubblePointPressure: +tab3Input?.bubblePoint || 0,
                    bubblePointPressureUnit: +tab3Input?.unitBubblePointListVal || 0,
                    TemperatureInput: +tab3Input?.bottomHoleTemp || 0,
                    TemperatureInputUnit: +tab3Input?.unitBottomHoleTempListVal || 0,
                    Frequency: +tab3Input?.operatngFreq || 0,
                    NoOfStages: +gasDetails?.noOfGasSeps || 0,
                    ChargePumpID: gasDetails?.chargePumpGKX || null,
                    Bg: +bg,
                    FLOP: +flop,
                    GOR: +GOR,
                    GasVolume: +gasVolume,
                    TFV: +TFV,
                    CompositeSpGravity: +combSpGr,
                    PIP: +finPIP,
                    CorrectionFactors: actionData?.type === "gasCalculation/setGasGKXCorrectionFactors" ? {
                        FlowCorrection: actionData?.payload?.flowCorrection / 100,
                        HeadCorrection: actionData?.payload?.headCorrection / 100,
                        PowerCorrection: actionData?.payload?.powerCorrection / 100
                    } : (+gasoutput?.GKX_FlowCorrection > 0 && +gasoutput?.GKX_HeadCorrection > 0 && +gasoutput?.GKX_PowerCorrection > 0 && actionData?.type !== "gasCalculation/setUseofChargePump") ? {
                        FlowCorrection: +gasoutput?.GKX_FlowCorrection / 100,
                        HeadCorrection: +gasoutput?.GKX_HeadCorrection / 100,
                        PowerCorrection: +gasoutput?.GKX_PowerCorrection / 100
                    } : null,
                    RegionName: selRegion?.name ?? selectedRegion ?? ''
                }

                return from(getGKXCalculations(postData_Obj)).pipe(
                    map(response => {
                        const result = response;
                        var gkxGasOutput = {} as GasCalculationOutPut;
                        gkxGasOutput.GKX_Rs = result?.rs;
                        gkxGasOutput.GKX_Bg = result?.bg;
                        gkxGasOutput.GKX_Bo = result?.bo;
                        gkxGasOutput.GKX_VolumeOfGas = result?.gasVolume;
                        gkxGasOutput.GKX_VolumeOfOil = result?.oIlVolume;
                        gkxGasOutput.GKX_VolumeOfWater = result?.waterVolume;
                        gkxGasOutput.GKX_TotalFluidVolume = result?.chargePumpSepTFV;
                        gkxGasOutput.GKX_FreeGas = result?.chargePumpSepFreeGas;
                        gkxGasOutput.GKX_GOR = result?.chargePumpSepGOR;
                        gkxGasOutput.GKX_GLR = result?.chargePumpGLR;
                        gkxGasOutput.GKX_GVF = result?.chargePumpSepGVF;
                        gkxGasOutput.GKX_LiquidPhaseDensity = result?.liquidPhaseDensity;
                        gkxGasOutput.GKX_GasCompressibility = result?.gasCompressibility;
                        gkxGasOutput.GKX_Pressure = result?.chargePumpTotalPressure;
                        gkxGasOutput.GKX_FinalComposite_SpGr = result?.compositeSpGr;
                        gkxGasOutput.GKX_FinalFLOP = result?.flop;
                        gkxGasOutput.GKX_FinalTemperature = result?.temperatureOutput;
                        gkxGasOutput.GKX_HPRating = result?.hp;
                        gkxGasOutput.GKX_FlowCorrection = result?.flowCorrection;
                        gkxGasOutput.GKX_HeadCorrection = result?.headCorrection;
                        gkxGasOutput.GKX_PowerCorrection = result?.powerCorrection;
                        gkxGasOutput.GKX_LiquidPhaseSpGr = result?.liquidPhaseSpGr;
                        return gkxGasOutput;
                    }),
                    mergeMap(
                        gkxGasOutput => {
                            return [
                                setGasOutputGKXData(gkxGasOutput),
                                fetchGasCP1Calculation(),
                            ]
                        })
                )
            }
            return [fetchGasCP1Calculation()];
        }),
    )
};

const getChargePump1Data = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("gasCalculation/setChargePump1CorrectionFactors", "gasCalculation/fetchGasCP1Calculation", "gasCalculation/setChargePumpSelected", "gasCalculation/setDesiredNoOfStages1"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.region)),
            state$.pipe(map((state: RootState) => state?.fluid?.regionList)),
            state$.pipe(map((state: RootState) => state?.fluid?.selectedRegion)),
        ),
        concatMap(([actionData, gasDetails, gasoutput, tab1Input, tab2Input, tab3Input, region, regionList, selectedRegion]) => {
            const selRegion = regionList?.find((x: any) => x?.id === region);
            if (gasDetails?.chargePumpDesrdStge && gasDetails?.chargePumpDesrdStge !== '' && gasDetails?.chargePump && gasDetails?.chargePump !== '') {
                let compSPGr: string | number | null = "";
                let finTemp: number | string | null = "";
                let GOR: number | string | null = tab3Input?.gor || "0";
                let GasComprs = tab3Input?.gasCompressibility?.toString() || "0";
                const gasAvail = tab3Input?.gasAvailblty?.toString() || "0";
                if (gasAvail == "0") {
                    GOR = "0";
                    GasComprs = "0";
                }
                let FLOP = tab2Input?.flop || 0;
                const useOfGKX = gasDetails?.useOfChgPmp;
                const noOfGasSeps = gasDetails?.noOfGasSeps;
                const gasSeperator = gasDetails?.sepSelcted;
                const GKX = gasDetails?.chargePumpGKX;
                const desrdNoOfStge = gasDetails?.chargePumpDesrdStge;

                let preTFV: number | string | null = "";
                let finPIP: number | string | null = "";
                let BG: number | string | null = "";
                let GasVolm: number | string | null = "";
                let oilVolume = 0; let waterVolume = 0;

                if (useOfGKX === '1' && GKX) {
                    preTFV = gasoutput?.GKX_TotalFluidVolume || 0;
                    finPIP = gasoutput?.GKX_Pressure || 0;
                    compSPGr = gasoutput?.GKX_FinalComposite_SpGr || 0;
                    GOR = gasoutput?.GKX_GOR || 0;
                    finTemp = gasoutput?.GKX_FinalTemperature || 0;
                    FLOP = gasoutput?.GKX_FinalFLOP || 0;
                    BG = gasoutput?.GKX_Bg || 0;
                    GasVolm = gasoutput?.GKX_VolumeOfGas || 0;
                } else if (+noOfGasSeps > 0 && gasSeperator) {
                    if (noOfGasSeps === '1') {
                        preTFV = gasoutput?.SP1_TotalFluidVolume || 0;
                        finPIP = gasoutput?.SP1_Pressure || 0;
                        compSPGr = gasoutput?.SP1_FinalComposite_SpGr || "0";
                        GOR = gasoutput?.SP1_GOR || 0;
                        finTemp = gasoutput?.SP1_FinalTemperature || 0;
                        FLOP = gasoutput?.SP1_FinalFLOP || 0;
                        BG = gasoutput?.SP1_Bg || 0;
                        GasVolm = gasoutput?.SP1_VolumeOfGas || 0;
                    }
                    else if (noOfGasSeps === '2') {
                        preTFV = gasoutput?.SP2_TotalFluidVolume || 0;
                        finPIP = gasoutput?.SP2_Pressure || 0;
                        compSPGr = gasoutput?.SP2_FinalComposite_SpGr || 0;
                        GOR = gasoutput?.SP2_GOR || 0;
                        finTemp = gasoutput?.SP2_FinalTemperature || 0;
                        FLOP = gasoutput?.SP2_FinalFLOP || 0;
                        BG = gasoutput?.SP2_Bg || 0;
                        GasVolm = gasoutput?.SP2_VolumeOfGas || 0;
                    }
                    else if (noOfGasSeps === '3') {
                        preTFV = gasoutput?.SP3_TotalFluidVolume || 0;
                        finPIP = gasoutput?.SP3_Pressure || 0;
                        compSPGr = gasoutput?.SP3_FinalComposite_SpGr || 0;
                        GOR = gasoutput?.SP3_GOR || 0;
                        finTemp = gasoutput?.SP3_FinalTemperature || 0;
                        FLOP = gasoutput?.SP3_FinalFLOP || 0;
                        BG = gasoutput?.SP3_Bg || 0;
                        GasVolm = gasoutput?.SP3_VolumeOfGas || 0;
                    }
                    else if (noOfGasSeps === '4') {
                        preTFV = gasoutput?.SP4_TotalFluidVolume || 0;
                        finPIP = gasoutput?.SP4_Pressure || 0;
                        compSPGr = gasoutput?.SP4_FinalComposite_SpGr || 0;
                        GOR = gasoutput?.SP4_GOR || 0;
                        finTemp = gasoutput?.SP4_FinalTemperature || 0;
                        FLOP = gasoutput?.SP4_FinalFLOP || 0;
                        BG = gasoutput?.SP4_Bg || 0;
                        GasVolm = gasoutput?.SP4_VolumeOfGas || 0;
                    }
                } else {
                    preTFV = gasoutput?.Intake_TotalFluidVolume || 0;
                    finPIP = gasoutput?.Intake_Pressure || 0;
                    compSPGr = gasoutput?.Intake_FinalComposite_SpGr || 0;
                    GOR = gasoutput?.Intake_GOR || 0;
                    finTemp = gasoutput?.Intake_FinalTemperature || 0;
                    FLOP = gasoutput?.Intake_FinalFLOP || 0;
                    BG = gasoutput?.Intake_Bg || 0;
                    GasVolm = gasoutput?.Intake_VolumeOfGas || 0;
                }
                const GasAvail = tab3Input?.gasAvailblty?.toString()
                let isGasVAl = "";
                if (GasAvail === "0") {
                    isGasVAl = "false";
                }
                if (GasAvail === "1") {
                    isGasVAl = "true";
                }
                const postData_Obj = {
                    UnitSystem: +tab1Input?.unitSys || 0,
                    CasingPressure: +tab2Input?.casingPressure || 0,
                    CasingPressureUnit: +tab2Input?.unitCasingPressureListVal || 0,
                    ProductionRate: +tab2Input?.productionRate || 0,
                    ProductionRateUnit: +tab2Input?.unitProductionRateListVal || 0,
                    PumpSetting: +tab2Input?.pumpSetting || 0,
                    PumpSettingUnit: +tab2Input?.unitPumpSettingListVal || 0,
                    Perforation: +tab2Input?.perforation || 0,
                    PerforationUnit: +tab2Input?.unitPerforationListVal || 0,
                    FLOP: +FLOP,
                    SpGrWater: +tab3Input?.spGrWater || 0,
                    WaterCut: +tab3Input?.waterCut || 0,
                    BWPD: +tab3Input?.bwpd || 0,
                    BWPDUnit: +tab3Input?.unitBWPDListVal || 0,
                    OilAPI: +tab3Input?.oilAPI || 0,
                    SpGrOil: +tab3Input?.spGrOil || 0,
                    BOPD: +tab3Input?.bopd || 0,
                    BOPDUnit: +tab3Input?.unitBOPDListVal || 0,
                    FluidViscosity: +tab3Input?.fluidViscosity || 0,
                    FluidViscosity_Unit: +tab3Input?.unitFluidViscosityListVal || 0,
                    IsGas: tab3Input?.gasAvailblty == "1" ? true : false,
                    GOR: Number(GOR),
                    GORUnit: +tab3Input?.unitGORListVal || 0,
                    SpGrGas: +tab3Input?.spGrGas || 0,
                    GasCompressibility: +tab3Input?.gasCompressibility || 0,
                    bubblePointPressure: +tab3Input?.bubblePoint || 0,
                    bubblePointPressureUnit: +tab3Input?.unitBubblePointListVal || 0,
                    TemperatureInput: +tab3Input?.bottomHoleTemp || 0,
                    TemperatureInputUnit: +tab3Input?.unitBottomHoleTempListVal || 0,
                    Temperature: Number(finTemp) || 0,
                    Frequency: +tab3Input?.operatngFreq || 0,
                    NoOfStages: +desrdNoOfStge || 0,
                    ChargePumpID: gasDetails?.chargePump || null,
                    HeadsPerStage: +gasDetails?.chargePumpHdPrStage || 12,
                    Bg: Number(BG),
                    GasVolume: Number(GasVolm),
                    OilVolume: +oilVolume,
                    WaterVolumee: +waterVolume,
                    TFV: Number(preTFV),
                    IntakeTotalFluidVolume: +gasoutput?.Intake_TotalFluidVolume || 0,
                    PreGreeGas: +gasoutput?.Intake_FreeGas || 0,
                    CompositeSpGravity: Number(compSPGr),
                    PIP: Number(finPIP),
                    CorrectionFactors: actionData.type === "gasCalculation/setChargePump1CorrectionFactors" ? {
                        FlowCorrection: actionData?.payload?.flowCorrection / 100,
                        HeadCorrection: actionData?.payload?.headCorrection / 100,
                        PowerCorrection: actionData?.payload?.powerCorrection / 100
                    } : (+gasoutput?.CP1_FlowCorrection > 0 && +gasoutput?.CP1_HeadCorrection > 0 && +gasoutput?.CP1_PowerCorrection > 0 && actionData.type !== "gasCalculation/setGasChargePump") ? {
                        FlowCorrection: +gasoutput?.CP1_FlowCorrection / 100,
                        HeadCorrection: +gasoutput?.CP1_HeadCorrection / 100,
                        PowerCorrection: +gasoutput?.CP1_PowerCorrection / 100
                    } : null,
                    RegionName: selRegion?.name ?? selectedRegion ?? ''
                }

                return from(GetGasChPmp1ChangeValues(postData_Obj)).pipe(
                    map(result => {
                        var cp1GasOutput = {} as GasCalculationOutPut;
                        cp1GasOutput.CP1_Rs = result?.rs;
                        cp1GasOutput.CP1_Bg = result?.bg;
                        cp1GasOutput.CP1_Bo = result?.bo;
                        cp1GasOutput.CP1_VolumeOfGas = result?.gasVolume;
                        cp1GasOutput.CP1_VolumeOfOil = result?.oIlVolume;
                        cp1GasOutput.CP1_VolumeOfWater = result?.waterVolume;
                        cp1GasOutput.CP1_TotalFluidVolume = result?.chargePumpSepTFV;
                        cp1GasOutput.CP1_FreeGas = result?.chargePumpSepFreeGas;
                        cp1GasOutput.CP1_GOR = result?.chargePumpSepGOR;
                        cp1GasOutput.CP1_GLR = result?.chargePumpGLR;
                        cp1GasOutput.CP1_GVF = result?.chargePumpSepGVF;
                        cp1GasOutput.CP1_LiquidPhaseDensity = result?.liquidPhaseDensity;
                        cp1GasOutput.CP1_GasCompressibility = result?.gasCompressibility;
                        cp1GasOutput.CP1_Pressure = result?.chargePumpTotalPressure;
                        cp1GasOutput.CP1_FinalComposite_SpGr = result?.compositeSpGr;
                        cp1GasOutput.CP1_FinalFLOP = result?.flop;
                        cp1GasOutput.CP1_FinalTemperature = result?.temperatureOutput;
                        cp1GasOutput.CP1_HPRating = result?.hp;
                        cp1GasOutput.CP1_FlowCorrection = result?.flowCorrection;
                        cp1GasOutput.CP1_HeadCorrection = result?.headCorrection;
                        cp1GasOutput.CP1_PowerCorrection = result?.powerCorrection;
                        cp1GasOutput.CP1_LiquidPhaseSpGr = result?.liquidPhaseSpGr;
                        return cp1GasOutput;
                    }),
                    mergeMap(cp1GasOutput => {
                        return [
                            setGasOutputCP1Data(cp1GasOutput),
                            fetchGasCP2Calculation(),
                        ]
                    })
                )
            }
            return [fetchGasCP2Calculation()];
        }),
    )
};

const getChargePump2Data = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("gasCalculation/setChargePump2CorrectionFactors", "gasCalculation/fetchGasCP2Calculation", "gasCalculation/setChargePump2Selected", "gasCalculation/setDesiredNoOfStages2"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.region)),
            state$.pipe(map((state: RootState) => state?.fluid?.regionList)),
            state$.pipe(map((state: RootState) => state?.fluid?.selectedRegion))
        ),
        concatMap(([actionData, gasDetails, gasoutput, tab1Input, tab2Input, tab3Input, region, regionList, selectedRegion]) => {
            const selRegion = regionList?.find((x: any) => x?.id === region);
            if (gasDetails?.chargePumpDesrdStge2 && gasDetails?.chargePumpDesrdStge2 !== '' && gasDetails?.chargePump2 && gasDetails?.chargePump2 != '') {
                let compSPGr: string | number | null = "";
                let finTemp: number | string | null = "";
                let GOR: number | string | null = tab3Input?.gor || "0";
                let GasComprs = tab3Input?.gasCompressibility?.toString() || "0";
                const gasAvail = tab3Input?.gasAvailblty?.toString() || "0";
                if (gasAvail == "0") {
                    GOR = "0";
                    GasComprs = "0";
                }
                let FLOP = tab2Input?.flop || 0;
                const useOfGKX = gasDetails?.useOfChgPmp;
                const noOfGasSeps = gasDetails?.noOfGasSeps;
                const gasSeperator = gasDetails?.sepSelcted;
                const GKX = gasDetails?.chargePumpGKX;
                const chargePump1 = gasDetails?.chargePump;
                const useChargePump = gasDetails?.useOfChgPmpNew;
                const pump1DesrdStages = gasDetails?.chargePumpDesrdStge;
                const desrdNoOfStge = gasDetails?.chargePumpDesrdStge2;
                let preTFV: number | string | null = "";
                let finPIP: number | string | null = "";
                let BG: number | string | null = "";
                let GasVolm: number | string | null = "";
                if (useChargePump === "1" && chargePump1 !== "" && pump1DesrdStages !== "") {
                    preTFV = gasoutput?.CP1_TotalFluidVolume || 0;
                    finPIP = gasoutput?.CP1_Pressure || 0;
                    compSPGr = gasoutput?.CP1_FinalComposite_SpGr || 0;
                    GOR = gasoutput?.CP1_GOR || 0;
                    finTemp = gasoutput?.CP1_FinalTemperature || 0;
                    FLOP = gasoutput?.CP1_FinalFLOP || 0;
                    BG = gasoutput?.CP1_Bg || 0;
                    GasVolm = gasoutput?.CP1_VolumeOfGas || 0;
                } else if (useOfGKX === '1' && GKX) {
                    preTFV = gasoutput?.GKX_TotalFluidVolume || 0;
                    finPIP = gasoutput?.GKX_Pressure || 0;
                    compSPGr = gasoutput?.GKX_FinalComposite_SpGr || 0;
                    GOR = gasoutput?.GKX_GOR || 0;
                    finTemp = gasoutput?.GKX_FinalTemperature || 0;
                    FLOP = gasoutput?.GKX_FinalFLOP || 0;
                    BG = gasoutput?.GKX_Bg || 0;
                    GasVolm = gasoutput?.GKX_VolumeOfGas || 0;
                } else if (+noOfGasSeps > 0 && gasSeperator) {
                    if (noOfGasSeps === '1') {
                        preTFV = gasoutput?.SP1_TotalFluidVolume || 0;
                        finPIP = gasoutput?.SP1_Pressure || 0;
                        compSPGr = gasoutput?.SP1_FinalComposite_SpGr || "0";
                        GOR = gasoutput?.SP1_GOR || 0;
                        finTemp = gasoutput?.SP1_FinalTemperature || 0;
                        FLOP = gasoutput?.SP1_FinalFLOP || 0;
                        BG = gasoutput?.SP1_Bg || 0;
                        GasVolm = gasoutput?.SP1_VolumeOfGas || 0;
                    }
                    else if (noOfGasSeps === '2') {
                        preTFV = gasoutput?.SP2_TotalFluidVolume || 0;
                        finPIP = gasoutput?.SP2_Pressure || 0;
                        compSPGr = gasoutput?.SP2_FinalComposite_SpGr || 0;
                        GOR = gasoutput?.SP2_GOR || 0;
                        finTemp = gasoutput?.SP2_FinalTemperature || 0;
                        FLOP = gasoutput?.SP2_FinalFLOP || 0;
                        BG = gasoutput?.SP2_Bg || 0;
                        GasVolm = gasoutput?.SP2_VolumeOfGas || 0;
                    }
                    else if (noOfGasSeps === '3') {
                        preTFV = gasoutput?.SP3_TotalFluidVolume || 0;
                        finPIP = gasoutput?.SP3_Pressure || 0;
                        compSPGr = gasoutput?.SP3_FinalComposite_SpGr || 0;
                        GOR = gasoutput?.SP3_GOR || 0;
                        finTemp = gasoutput?.SP3_FinalTemperature || 0;
                        FLOP = gasoutput?.SP3_FinalFLOP || 0;
                        BG = gasoutput?.SP3_Bg || 0;
                        GasVolm = gasoutput?.SP3_VolumeOfGas || 0;
                    }
                    else if (noOfGasSeps === '4') {
                        preTFV = gasoutput?.SP4_TotalFluidVolume || 0;
                        finPIP = gasoutput?.SP4_Pressure || 0;
                        compSPGr = gasoutput?.SP4_FinalComposite_SpGr || 0;
                        GOR = gasoutput?.SP4_GOR || 0;
                        finTemp = gasoutput?.SP4_FinalTemperature || 0;
                        FLOP = gasoutput?.SP4_FinalFLOP || 0;
                        BG = gasoutput?.SP4_Bg || 0;
                        GasVolm = gasoutput?.SP4_VolumeOfGas || 0;
                    }
                } else {
                    preTFV = gasoutput?.Intake_TotalFluidVolume || 0;
                    finPIP = gasoutput?.Intake_Pressure || 0;
                    compSPGr = gasoutput?.Intake_FinalComposite_SpGr || 0;
                    GOR = gasoutput?.Intake_GOR || 0;
                    finTemp = gasoutput?.Intake_FinalTemperature || 0;
                    FLOP = gasoutput?.Intake_FinalFLOP || 0;
                    BG = gasoutput?.Intake_Bg || 0;
                    GasVolm = gasoutput?.Intake_VolumeOfGas || 0;
                }
                const GasAvail = tab3Input?.gasAvailblty;
                let isGasVAl = "";
                if (GasAvail == "0") {
                    isGasVAl = "false";
                }
                if (GasAvail == "1") {
                    isGasVAl = "true";
                }

                const postData_Obj = {
                    UnitSystem: +tab1Input?.unitSys || 0,
                    CasingPressure: +tab2Input?.casingPressure || 0,
                    CasingPressureUnit: +tab2Input?.unitCasingPressureListVal || 0,
                    ProductionRate: +tab2Input?.productionRate || 0,
                    ProductionRateUnit: +tab2Input?.unitProductionRateListVal || 0,
                    PumpSetting: +tab2Input?.pumpSetting || 0,
                    PumpSettingUnit: +tab2Input?.unitPumpSettingListVal || 0,
                    Perforation: +tab2Input?.perforation || 0,
                    PerforationUnit: +tab2Input?.unitPerforationListVal || 0,
                    FLOP: +FLOP,
                    SpGrWater: +tab3Input?.spGrWater || 0,
                    WaterCut: +tab3Input?.waterCut || 0,
                    BWPD: +tab3Input?.bwpd || 0,
                    BWPDUnit: +tab3Input?.unitBWPDListVal || 0,
                    OilAPI: +tab3Input?.oilAPI || 0,
                    SpGrOil: +tab3Input?.spGrOil || 0,
                    BOPD: +tab3Input?.bopd || 0,
                    BOPDUnit: +tab3Input?.unitBOPDListVal || 0,
                    FluidViscosity: +tab3Input?.fluidViscosity || 0,
                    FluidViscosity_Unit: +tab3Input?.unitFluidViscosityListVal || 0,
                    IsGas: tab3Input?.gasAvailblty == "1" ? true : false,
                    GOR: Number(GOR),
                    GORUnit: +tab3Input?.unitGORListVal || 0,
                    SpGrGas: +tab3Input?.spGrGas || 0,
                    GasCompressibility: +tab3Input?.gasCompressibility || 0,
                    bubblePointPressure: +tab3Input?.bubblePoint || 0,
                    bubblePointPressureUnit: +tab3Input?.unitBubblePointListVal || 0,
                    TemperatureInput: +tab3Input?.bottomHoleTemp || 0,
                    TemperatureInputUnit: +tab3Input?.unitBottomHoleTempListVal || 0,
                    Temperature: Number(finTemp) || 0,
                    Frequency: +tab3Input?.operatngFreq || 0,
                    NoOfStages: +desrdNoOfStge || 0,
                    ChargePumpID: gasDetails?.chargePump2 || null,
                    HeadsPerStage: +gasDetails?.chargePumpHdPrStage || 12,
                    Bg: Number(BG),
                    GasVolume: Number(GasVolm),
                    TFV: Number(preTFV),
                    IntakeTotalFluidVolume: Number(gasoutput?.Intake_TotalFluidVolume) || 0,
                    PreGreeGas: +gasoutput?.Intake_FreeGas || 0,
                    CompositeSpGravity: Number(compSPGr),
                    PIP: Number(finPIP),
                    CorrectionFactors: actionData.type === "gasCalculation/setChargePump2CorrectionFactors" ? {
                        FlowCorrection: actionData?.payload?.flowCorrection / 100,
                        HeadCorrection: actionData?.payload?.headCorrection / 100,
                        PowerCorrection: actionData?.payload?.powerCorrection / 100
                    } : (+gasoutput?.CP2_FlowCorrection > 0 && +gasoutput?.CP2_HeadCorrection > 0 && +gasoutput?.CP2_PowerCorrection > 0 && actionData?.type !== "gasCalculation/setGasChargePump2") ? {
                        FlowCorrection: +gasoutput?.CP2_FlowCorrection / 100,
                        HeadCorrection: +gasoutput?.CP2_HeadCorrection / 100,
                        PowerCorrection: +gasoutput?.CP2_PowerCorrection / 100
                    } : null,
                    RegionName: selRegion?.name ?? selectedRegion ?? ''
                };
                return from(GetGasChPmp1ChangeValues(postData_Obj)).pipe(
                    map(result => {
                        var cp2GasOutput = {
                            CP2_Rs: result?.rs,
                            CP2_Bg: result?.bg,
                            CP2_Bo: result?.bo,
                            CP2_VolumeOfGas: result?.gasVolume,
                            CP2_VolumeOfOil: result?.oIlVolume,
                            CP2_VolumeOfWater: result?.waterVolume,
                            CP2_TotalFluidVolume: result?.chargePumpSepTFV,
                            CP2_FreeGas: result?.chargePumpSepFreeGas,
                            CP2_GOR: result?.chargePumpSepGOR,
                            CP2_GLR: result?.chargePumpGLR, CP2_GVF: result?.chargePumpSepGVF,
                            CP2_LiquidPhaseDensity: result?.liquidPhaseDensity,
                            CP2_GasCompressibility: result?.gasCompressibility,
                            CP2_Pressure: result?.chargePumpTotalPressure,
                            CP2_FinalComposite_SpGr: result?.compositeSpGr,
                            CP2_FinalFLOP: result?.flop,
                            CP2_FinalTemperature: result?.temperatureOutput,
                            CP2_HPRating: result?.hp,
                            CP2_FlowCorrection: result?.flowCorrection,
                            CP2_HeadCorrection: result?.headCorrection,
                            CP2_PowerCorrection: result?.powerCorrection,
                            CP2_LiquidPhaseSpGr: result?.liquidPhaseSpGr
                        } as GasCalculationOutPut;

                        return cp2GasOutput;
                    }),
                    mergeMap(cp2GasOutput => {
                        return [
                            setGasOutputCP2Data(cp2GasOutput),
                            fetchGasCP3Calculation()
                        ]
                    })
                )
            }
            return [fetchGasCP3Calculation()];
        }),
    )
};

const getChargePump3Data = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("gasCalculation/setChargePump3CorrectionFactors", "gasCalculation/fetchGasCP3Calculation", "gasCalculation/setChargePump3Selected", "gasCalculation/setDesiredNoOfStages3"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
            state$.pipe(map((state: RootState) => state?.fluid?.region)),
            state$.pipe(map((state: RootState) => state?.fluid?.regionList)),
            state$.pipe(map((state: RootState) => state?.fluid?.selectedRegion))
        ),
        concatMap(([actionData, gasDetails, gasoutput, tab1Input, tab2Input, tab3Input, region, regionList, selectedRegion]) => {
            const selRegion = regionList?.find((x: any) => x?.id === region);
            if (gasDetails?.chargePumpDesrdStge3 && gasDetails?.chargePumpDesrdStge3 != '' && gasDetails?.chargePump3 && gasDetails?.chargePump3 != '') {
                let compSPGr: string | number | null = "";
                let finTemp: number | string | null = "";
                let GOR: number | string | null = tab3Input?.gor || "0";
                let GasComprs = tab3Input?.gasCompressibility?.toString() || "0";
                const gasAvail = tab3Input?.gasAvailblty?.toString() || "0";
                if (gasAvail == "0") {
                    GOR = "0";
                    GasComprs = "0";
                }
                let FLOP = tab2Input?.flop || 0;
                const useOfGKX = gasDetails?.useOfChgPmp;
                const noOfGasSeps = gasDetails?.noOfGasSeps;
                const gasSeperator = gasDetails?.sepSelcted;
                const GKX = gasDetails?.chargePumpGKX;
                const chargePump1 = gasDetails?.chargePump;
                const chargePump2 = gasDetails?.chargePump2;
                const useChargePump = gasDetails?.useOfChgPmpNew;
                const pump1DesrdStages = gasDetails?.chargePumpDesrdStge;
                const pump2DesrdStages = gasDetails?.chargePumpDesrdStge2;
                const desrdNoOfStge = gasDetails?.chargePumpDesrdStge3;
                let preTFV: number | string | null = "";
                let finPIP: number | string | null = "";
                let BG: number | string | null = "";
                let GasVolm: number | string | null = "";
                if (useChargePump === "1" && chargePump2 !== "" && pump2DesrdStages !== "") {
                    preTFV = gasoutput?.CP2_TotalFluidVolume || 0;
                    finPIP = gasoutput?.CP2_Pressure || 0;
                    compSPGr = gasoutput?.CP2_FinalComposite_SpGr || 0;
                    GOR = gasoutput?.CP2_GOR || 0;
                    finTemp = gasoutput?.CP2_FinalTemperature || 0;
                    FLOP = gasoutput?.CP2_FinalFLOP || 0;
                    BG = gasoutput?.CP2_Bg || 0;
                    GasVolm = gasoutput?.CP2_VolumeOfGas || 0;
                } else if (useChargePump === "1" && chargePump1 !== "" && pump1DesrdStages !== "") {
                    preTFV = gasoutput?.CP1_TotalFluidVolume || 0;
                    finPIP = gasoutput?.CP1_Pressure || 0;
                    compSPGr = gasoutput?.CP1_FinalComposite_SpGr || 0;
                    GOR = gasoutput?.CP1_GOR || 0;
                    finTemp = gasoutput?.CP1_FinalTemperature || 0;
                    FLOP = gasoutput?.CP1_FinalFLOP || 0;
                    BG = gasoutput?.CP1_Bg || 0;
                    GasVolm = gasoutput?.CP1_VolumeOfGas || 0;
                } else if (useOfGKX === '1' && GKX) {
                    preTFV = gasoutput?.GKX_TotalFluidVolume || 0;
                    finPIP = gasoutput?.GKX_Pressure || 0;
                    compSPGr = gasoutput?.GKX_FinalComposite_SpGr || 0;
                    GOR = gasoutput?.GKX_GOR || 0;
                    finTemp = gasoutput?.GKX_FinalTemperature || 0;
                    FLOP = gasoutput?.GKX_FinalFLOP || 0;
                    BG = gasoutput?.GKX_Bg || 0;
                    GasVolm = gasoutput?.GKX_VolumeOfGas || 0;
                } else if (+noOfGasSeps > 0 && gasSeperator) {
                    if (noOfGasSeps === '1') {
                        preTFV = gasoutput?.SP1_TotalFluidVolume || 0;
                        finPIP = gasoutput?.SP1_Pressure || 0;
                        compSPGr = gasoutput?.SP1_FinalComposite_SpGr || "0";
                        GOR = gasoutput?.SP1_GOR || 0;
                        finTemp = gasoutput?.SP1_FinalTemperature || 0;
                        FLOP = gasoutput?.SP1_FinalFLOP || 0;
                        BG = gasoutput?.SP1_Bg || 0;
                        GasVolm = gasoutput?.SP1_VolumeOfGas || 0;
                    }
                    else if (noOfGasSeps === '2') {
                        preTFV = gasoutput?.SP2_TotalFluidVolume || 0;
                        finPIP = gasoutput?.SP2_Pressure || 0;
                        compSPGr = gasoutput?.SP2_FinalComposite_SpGr || 0;
                        GOR = gasoutput?.SP2_GOR || 0;
                        finTemp = gasoutput?.SP2_FinalTemperature || 0;
                        FLOP = gasoutput?.SP2_FinalFLOP || 0;
                        BG = gasoutput?.SP2_Bg || 0;
                        GasVolm = gasoutput?.SP2_VolumeOfGas || 0;
                    }
                    else if (noOfGasSeps === '3') {
                        preTFV = gasoutput?.SP3_TotalFluidVolume || 0;
                        finPIP = gasoutput?.SP3_Pressure || 0;
                        compSPGr = gasoutput?.SP3_FinalComposite_SpGr || 0;
                        GOR = gasoutput?.SP3_GOR || 0;
                        finTemp = gasoutput?.SP3_FinalTemperature || 0;
                        FLOP = gasoutput?.SP3_FinalFLOP || 0;
                        BG = gasoutput?.SP3_Bg || 0;
                        GasVolm = gasoutput?.SP3_VolumeOfGas || 0;
                    }
                    else if (noOfGasSeps === '4') {
                        preTFV = gasoutput?.SP4_TotalFluidVolume || 0;
                        finPIP = gasoutput?.SP4_Pressure || 0;
                        compSPGr = gasoutput?.SP4_FinalComposite_SpGr || 0;
                        GOR = gasoutput?.SP4_GOR || 0;
                        finTemp = gasoutput?.SP4_FinalTemperature || 0;
                        FLOP = gasoutput?.SP4_FinalFLOP || 0;
                        BG = gasoutput?.SP4_Bg || 0;
                        GasVolm = gasoutput?.SP4_VolumeOfGas || 0;
                    }
                } else {
                    preTFV = gasoutput?.Intake_TotalFluidVolume || 0;
                    finPIP = gasoutput?.Intake_Pressure || 0;
                    compSPGr = gasoutput?.Intake_FinalComposite_SpGr || 0;
                    GOR = gasoutput?.Intake_GOR || 0;
                    finTemp = gasoutput?.Intake_FinalTemperature || 0;
                    FLOP = gasoutput?.Intake_FinalFLOP || 0;
                    BG = gasoutput?.Intake_Bg || 0;
                    GasVolm = gasoutput?.Intake_VolumeOfGas || 0;
                }
                const GasAvail = tab3Input?.gasAvailblty;
                let isGasVAl = "";
                if (GasAvail == "0") {
                    isGasVAl = "false";
                }
                if (GasAvail == "1") {
                    isGasVAl = "true";
                }

                const postData_Obj = {
                    UnitSystem: +tab1Input?.unitSys || 0,
                    CasingPressure: +tab2Input?.casingPressure || 0,
                    CasingPressureUnit: +tab2Input?.unitCasingPressureListVal || 0,
                    ProductionRate: +tab2Input?.productionRate || 0,
                    ProductionRateUnit: +tab2Input?.unitProductionRateListVal || 0,
                    PumpSetting: +tab2Input?.pumpSetting || 0,
                    PumpSettingUnit: +tab2Input?.unitPumpSettingListVal || 0,
                    Perforation: +tab2Input?.perforation || 0,
                    PerforationUnit: +tab2Input?.unitPerforationListVal || 0,
                    FLOP: +FLOP,
                    SpGrWater: +tab3Input?.spGrWater || 0,
                    WaterCut: +tab3Input?.waterCut || 0,
                    BWPD: +tab3Input?.bwpd || 0,
                    BWPDUnit: +tab3Input?.unitBWPDListVal || 0,
                    OilAPI: +tab3Input?.oilAPI || 0,
                    SpGrOil: +tab3Input?.spGrOil || 0,
                    BOPD: +tab3Input?.bopd || 0,
                    BOPDUnit: +tab3Input?.unitBOPDListVal || 0,
                    FluidViscosity: +tab3Input?.fluidViscosity || 0,
                    FluidViscosity_Unit: +tab3Input?.unitFluidViscosityListVal || 0,
                    IsGas: tab3Input?.gasAvailblty == "1" ? true : false,
                    GOR: Number(GOR),
                    GORUnit: +tab3Input?.unitGORListVal || 0,
                    SpGrGas: +tab3Input?.spGrGas || 0,
                    GasCompressibility: +tab3Input?.gasCompressibility || 0,
                    bubblePointPressure: +tab3Input?.bubblePoint || 0,
                    bubblePointPressureUnit: +tab3Input?.unitBubblePointListVal || 0,
                    TemperatureInput: +tab3Input?.bottomHoleTemp || 0,
                    TemperatureInputUnit: +tab3Input?.unitBottomHoleTempListVal || 0,
                    Temperature: Number(finTemp) || 0,
                    Frequency: +tab3Input?.operatngFreq || 0,
                    NoOfStages: +desrdNoOfStge || 0,
                    ChargePumpID: gasDetails?.chargePump3 || null,
                    HeadsPerStage: +gasDetails?.chargePumpHdPrStage || 12,
                    Bg: Number(BG),
                    GasVolume: Number(GasVolm),
                    TFV: Number(preTFV),
                    IntakeTotalFluidVolume: +gasoutput?.Intake_TotalFluidVolume || 0,
                    PreGreeGas: +gasoutput?.Intake_FreeGas || 0,
                    CompositeSpGravity: Number(compSPGr),
                    PIP: Number(finPIP),
                    CorrectionFactors: actionData?.type === "gasCalculation/setChargePump3CorrectionFactors" ? {
                        FlowCorrection: actionData?.payload?.flowCorrection / 100,
                        HeadCorrection: actionData?.payload?.headCorrection / 100,
                        PowerCorrection: actionData?.payload?.powerCorrection / 100
                    } : (+gasoutput?.CP3_FlowCorrection > 0 && +gasoutput?.CP3_HeadCorrection > 0 && +gasoutput?.CP3_PowerCorrection > 0 && actionData?.type !== "gasCalculation/setChargePumpDesrdstg3") ? {
                        FlowCorrection: +gasoutput?.CP3_FlowCorrection / 100,
                        HeadCorrection: +gasoutput?.CP3_HeadCorrection / 100,
                        PowerCorrection: +gasoutput?.CP3_PowerCorrection / 100
                    } : null,
                    RegionName: selRegion?.name ?? selectedRegion ?? ''
                }

                return from(GetGasChPmp1ChangeValues(postData_Obj)).pipe(
                    map(result => {
                        var cp3GasOutput = {
                            CP3_Rs: result?.rs,
                            CP3_Bg: result?.bg,
                            CP3_Bo: result?.bo,
                            CP3_VolumeOfGas: result?.gasVolume,
                            CP3_VolumeOfOil: result?.oIlVolume,
                            CP3_VolumeOfWater: result?.waterVolume,
                            CP3_TotalFluidVolume: result?.chargePumpSepTFV,
                            CP3_FreeGas: result?.chargePumpSepFreeGas,
                            CP3_GOR: result?.chargePumpSepGOR,
                            CP3_GLR: result?.chargePumpGLR,
                            CP3_GVF: result?.chargePumpSepGVF,
                            CP3_LiquidPhaseDensity: result?.liquidPhaseDensity,
                            CP3_GasCompressibility: result?.gasCompressibility,
                            CP3_Pressure: result?.chargePumpTotalPressure,
                            CP3_FinalComposite_SpGr: result?.compositeSpGr,
                            CP3_FinalFLOP: result?.flop,
                            CP3_FinalTemperature: result?.temperatureOutput,
                            CP3_HPRating: result?.hp,
                            CP3_FlowCorrection: result?.flowCorrection,
                            CP3_HeadCorrection: result?.headCorrection,
                            CP3_PowerCorrection: result?.powerCorrection,
                            CP3_LiquidPhaseSpGr: result?.liquidPhaseSpGr
                        } as GasCalculationOutPut;
                        return cp3GasOutput;
                    }),
                    mergeMap(cp3GasOutput => {
                        return [
                            setGasOutputCP3Data(cp3GasOutput),
                            fetchFinalCalculationData(),
                        ]
                    })
                )
            }
            return of(fetchFinalCalculationData());
        })
    )
}

const calculateTFVFinal = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("gasCalculation/fetchFinalCalculationData"),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)),
        ),
        map(([actionData, gasInput, gasOutPut]) => {
            var preTFV = "";
            var finPIP = '';
            var compSPGr = '';
            var GOR = '';
            var temp = "";
            var FLOP = '';
            var BG = '';;
            var GasVolm = '';
            var VolumeOfOil = '';
            var VolumeOfWater = '';
            var liquidPhaseDensity = '';
            var FreeGasGvf = '';
            var Pressure = '';
            if (gasInput?.useOfChgPmpNew === '1') {
                if (gasInput?.chargePump3?.length && gasInput?.chargePumpDesrdStge3 > 0) {
                    preTFV = gasOutPut?.CP3_TotalFluidVolume?.toString();
                    finPIP = gasOutPut?.CP3_Pressure?.toString();
                    compSPGr = gasOutPut?.CP3_FinalComposite_SpGr?.toString();
                    GOR = gasOutPut?.CP3_GOR?.toString();
                    temp = gasOutPut?.CP3_FinalTemperature?.toString();
                    FLOP = gasOutPut?.CP3_FinalFLOP?.toString();
                    BG = gasOutPut?.CP3_Bg?.toString();
                    GasVolm = gasOutPut?.CP3_VolumeOfGas?.toString();
                    VolumeOfOil = gasOutPut?.CP3_VolumeOfOil?.toString();
                    VolumeOfWater = gasOutPut?.CP3_VolumeOfWater?.toString();
                    liquidPhaseDensity = gasOutPut?.CP3_LiquidPhaseDensity?.toString();
                    FreeGasGvf = gasOutPut?.CP3_FreeGas?.toString();
                    Pressure = gasOutPut?.CP3_Pressure?.toString();
                }
                else if (gasInput?.chargePump2?.length && gasInput?.chargePumpDesrdStge2 > 0) {
                    preTFV = gasOutPut?.CP2_TotalFluidVolume?.toString();
                    finPIP = gasOutPut?.CP2_Pressure?.toString();
                    compSPGr = gasOutPut?.CP2_FinalComposite_SpGr?.toString();
                    GOR = gasOutPut?.CP2_GOR?.toString();
                    temp = gasOutPut?.CP2_FinalTemperature?.toString();
                    FLOP = gasOutPut?.CP2_FinalFLOP?.toString();
                    BG = gasOutPut?.CP2_Bg?.toString();
                    GasVolm = gasOutPut?.CP2_VolumeOfGas?.toString();
                    VolumeOfOil = gasOutPut?.CP2_VolumeOfOil?.toString();
                    VolumeOfWater = gasOutPut?.CP2_VolumeOfWater?.toString();
                    liquidPhaseDensity = gasOutPut?.CP2_LiquidPhaseDensity?.toString();
                    FreeGasGvf = gasOutPut?.CP2_FreeGas?.toString();
                    Pressure = gasOutPut?.CP2_Pressure?.toString();
                }
                else if (gasInput?.chargePump?.length && gasInput?.chargePumpDesrdStge > 0) {
                    preTFV = gasOutPut?.CP1_TotalFluidVolume?.toString();
                    finPIP = gasOutPut?.CP1_Pressure?.toString();
                    compSPGr = gasOutPut?.CP1_FinalComposite_SpGr?.toString();
                    GOR = gasOutPut?.CP1_GOR?.toString();
                    temp = gasOutPut?.CP1_FinalTemperature?.toString();
                    FLOP = gasOutPut?.CP1_FinalFLOP?.toString();
                    BG = gasOutPut?.CP1_Bg?.toString();
                    GasVolm = gasOutPut?.CP1_VolumeOfGas?.toString();
                    VolumeOfOil = gasOutPut?.CP1_VolumeOfOil?.toString();
                    VolumeOfWater = gasOutPut?.CP1_VolumeOfWater?.toString();
                    liquidPhaseDensity = gasOutPut?.CP1_LiquidPhaseDensity?.toString();
                    FreeGasGvf = gasOutPut?.CP1_FreeGas?.toString();
                    Pressure = gasOutPut?.CP1_Pressure?.toString();
                }
            }

            if (preTFV === '' && gasInput?.useOfChgPmp === '1' && gasInput?.chargePumpGKX?.length) {
                preTFV = gasOutPut?.GKX_TotalFluidVolume?.toString();
                finPIP = gasOutPut?.GKX_Pressure?.toString();
                compSPGr = gasOutPut?.GKX_FinalComposite_SpGr?.toString();
                GOR = gasOutPut?.GKX_GOR?.toString();
                temp = gasOutPut?.GKX_FinalTemperature?.toString();
                FLOP = gasOutPut?.GKX_FinalFLOP?.toString();
                BG = gasOutPut?.GKX_Bg?.toString();
                GasVolm = gasOutPut?.GKX_VolumeOfGas?.toString();
                VolumeOfOil = gasOutPut?.GKX_VolumeOfOil?.toString();
                VolumeOfWater = gasOutPut?.GKX_VolumeOfWater?.toString();
                liquidPhaseDensity = gasOutPut?.GKX_LiquidPhaseDensity?.toString();
                FreeGasGvf = gasOutPut?.GKX_FreeGas?.toString();
                Pressure = gasOutPut?.GKX_Pressure?.toString();;
            }

            if (preTFV === '' && gasInput?.noOfGasSeps?.length && +gasInput?.noOfGasSeps > 0 && gasInput?.sepSelcted?.length) {
                if (gasInput?.noOfGasSeps === '4') {
                    preTFV = gasOutPut?.SP4_TotalFluidVolume?.toString();
                    finPIP = gasOutPut?.SP4_Pressure?.toString();
                    compSPGr = gasOutPut?.SP4_FinalComposite_SpGr?.toString();
                    GOR = gasOutPut?.SP4_GOR?.toString();
                    temp = gasOutPut?.SP4_FinalTemperature?.toString();
                    FLOP = gasOutPut?.SP4_FinalFLOP?.toString();
                    BG = gasOutPut?.SP4_Bg?.toString();
                    GasVolm = gasOutPut?.SP4_VolumeOfGas?.toString();
                    VolumeOfOil = gasOutPut?.SP4_VolumeOfOil?.toString();
                    VolumeOfWater = gasOutPut?.SP4_VolumeOfWater?.toString();
                    liquidPhaseDensity = gasOutPut?.SP4_LiquidPhaseDensity?.toString();
                    FreeGasGvf = gasOutPut?.SP4_FreeGas?.toString();
                    Pressure = gasOutPut?.SP4_Pressure?.toString();
                }
                if (gasInput?.noOfGasSeps === '3') {
                    preTFV = gasOutPut?.SP3_TotalFluidVolume?.toString();
                    finPIP = gasOutPut?.SP3_Pressure?.toString();
                    compSPGr = gasOutPut?.SP3_FinalComposite_SpGr?.toString();
                    GOR = gasOutPut?.SP3_GOR?.toString();
                    temp = gasOutPut?.SP3_FinalTemperature?.toString();
                    FLOP = gasOutPut?.SP3_FinalFLOP?.toString();
                    BG = gasOutPut?.SP3_Bg?.toString();
                    GasVolm = gasOutPut?.SP3_VolumeOfGas?.toString();
                    VolumeOfOil = gasOutPut?.SP3_VolumeOfOil?.toString();
                    VolumeOfWater = gasOutPut?.SP3_VolumeOfWater?.toString();
                    liquidPhaseDensity = gasOutPut?.SP3_LiquidPhaseDensity?.toString();
                    FreeGasGvf = gasOutPut?.SP3_FreeGas?.toString();
                    Pressure = gasOutPut?.SP3_Pressure?.toString();
                }
                if (gasInput?.noOfGasSeps === '2') {
                    preTFV = gasOutPut?.SP2_TotalFluidVolume?.toString();
                    finPIP = gasOutPut?.SP2_Pressure?.toString();
                    compSPGr = gasOutPut?.SP2_FinalComposite_SpGr?.toString();
                    GOR = gasOutPut?.SP2_GOR?.toString()
                    temp = gasOutPut?.SP2_FinalTemperature?.toString();
                    FLOP = gasOutPut?.SP2_FinalFLOP?.toString();
                    BG = gasOutPut?.SP2_Bg?.toString();
                    GasVolm = gasOutPut?.SP2_VolumeOfGas?.toString();
                    VolumeOfOil = gasOutPut?.SP2_VolumeOfOil?.toString();
                    VolumeOfWater = gasOutPut?.SP2_VolumeOfWater?.toString();
                    liquidPhaseDensity = gasOutPut?.SP2_LiquidPhaseDensity?.toString();
                    FreeGasGvf = gasOutPut?.SP2_FreeGas?.toString();
                    Pressure = gasOutPut?.SP2_Pressure?.toString();
                }
                if (gasInput?.noOfGasSeps === '1') {
                    preTFV = gasOutPut?.SP1_TotalFluidVolume?.toString();
                    finPIP = gasOutPut?.SP1_Pressure?.toString();
                    compSPGr = gasOutPut?.SP1_FinalComposite_SpGr?.toString();
                    GOR = gasOutPut?.SP1_GOR?.toString();
                    temp = gasOutPut?.SP1_FinalTemperature?.toString();
                    FLOP = gasOutPut?.SP1_FinalFLOP?.toString();
                    BG = gasOutPut?.SP1_Bg?.toString();
                    GasVolm = gasOutPut?.SP1_VolumeOfGas?.toString();
                    VolumeOfOil = gasOutPut?.SP1_VolumeOfOil?.toString();;
                    VolumeOfWater = gasOutPut?.SP1_VolumeOfWater?.toString();
                    liquidPhaseDensity = gasOutPut?.SP1_LiquidPhaseDensity?.toString();
                    FreeGasGvf = gasOutPut?.SP1_FreeGas?.toString();
                    Pressure = gasOutPut?.SP1_Pressure?.toString();
                }
            }
            if (preTFV === '' || preTFV == null || preTFV == undefined) {
                preTFV = gasOutPut?.Intake_TotalFluidVolume?.toString();
                finPIP = gasOutPut?.Intake_Pressure?.toString();
                compSPGr = gasOutPut?.Intake_FinalComposite_SpGr?.toString();
                GOR = gasOutPut?.Intake_GOR?.toString();
                temp = gasOutPut?.Intake_FinalTemperature?.toString();
                FLOP = gasOutPut?.Intake_FinalFLOP?.toString();
                BG = gasOutPut?.Intake_Bg?.toString();
                GasVolm = gasOutPut?.Intake_VolumeOfGas?.toString();
                VolumeOfOil = gasOutPut?.Intake_VolumeOfOil?.toString();
                VolumeOfWater = gasOutPut?.Intake_VolumeOfWater?.toString();
                liquidPhaseDensity = gasOutPut?.Intake_LiquidPhaseDensity?.toString();
                FreeGasGvf = gasOutPut?.Intake_FreeGas?.toString();
                Pressure = gasOutPut?.Intake_Pressure?.toString();
            }

            var calculatedData = {
                preTFV: preTFV,
                finPIP: finPIP,
                BG: BG,
                compSPGr: compSPGr,
                GOR: GOR,
                temp: temp,
                FLOP: FLOP,
                GasVolm: GasVolm,
                VolumeOfOil: VolumeOfOil,
                VolumeOfWater: VolumeOfWater,
                LiquidPhaseDensity: liquidPhaseDensity,
                FreeGasGvf: FreeGasGvf,
                Pressure: Pressure,
            } as FinalCalculatedData;
            return calculatedData;
        }),
        mergeMap(data => {
            return [
                setFinalCalculationData(data),
                setGasCalculationComplete(true),
            ]
        }),
    )
};

const loadSeperatorList = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "tubing/setCatalogType",
            "gasCalculation/setGasCalculationComplete",
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.GasCalculationComplete)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)),
        ),
        filter(([actionData, tab1Input, gasOutput, gasComplete, gasCalculation]) => [tab1Input, gasOutput, gasComplete, gasCalculation].every(x => x !== null && x !== undefined)),
        concatMap(([actionData, tab1Input, gasOutput, gasComplete, gasCalculation]) => {

            if (gasComplete === true) {
                const totalFluidVolume = gasOutput?.Intake_TotalFluidVolume ?? 0;
                const unitSys = +tab1Input?.unitSys;
                const casingIdUnit = +tab1Input?.unitCasingIDListVal;
                const tfvUnit = +tab1Input?.hdnGas_TotalFluidVolume;
                const casingId = +tab1Input?.casingID;
                const catalogFilter = actionData.type === "tubing/setCatalogType" ? actionData.payload : +tab1Input?.catalogType;
                const payload = {
                    CasingID: casingId,
                    TFV: totalFluidVolume,
                    UnitSys: unitSys,
                    CasingIDUnit: casingIdUnit,
                    TFVUnt: tfvUnit,
                    catalogFilter: catalogFilter
                };

                return from(getSeparatorList(payload)).pipe(
                    mergeMap(data => {
                        if (Object.keys(data?.SeparatorList).length > 0) {
                            const sepName = gasCalculation?.sepSelcted !== "" ? convertObjToDropdown(data?.SeparatorList)?.find(x => x?.id === gasCalculation?.sepSelcted) : { id: "", label: "" };
                            const selectedSep = actionData?.type === "tubing/setCatalogType" ? sepName ? sepName?.label : "" : sepName?.label;
                            return [
                                setSepName(selectedSep),
                                setGasSeparatorList(data?.SeparatorList),
                            ];
                        }
                        return [
                            setGasSeparatorList(gasCalculation?.separatorList),
                        ];
                    }),
                )
            }
            return EMPTY;
        }),
    )
};

const fetchEquipmentsSeparator = (action$: any, state$: any) => {
    return action$.pipe(
        ofType(
            "gasCalculation/fetchGasSeparatorEquipments",
            "gasCalculation/setSelectedGasSeparator"
        ),
        withLatestFrom(
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation?.separatorList)),
            state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
            state$.pipe(map((state: RootState) => state?.gasCalculations?.BasicGasCalculation?.sepSelcted)),
        ),
        switchMap(([actionData, separatorList, tab1Input, sepSelected]) => {
            const selectedSep = separatorList && Object?.keys(separatorList)?.length > 0 ? convertObjToDropdown(separatorList)?.find((x: any) => x?.id === sepSelected) : { id: "", label: "", series: "", seriesType: "" };
            if (sepSelected === undefined) {
                return [setExistedGasSepEquipments([])];
            } else if (sepSelected !== "") {
                const payload = {
                    series: selectedSep?.series,
                    seriesType: selectedSep?.seriesType,
                    catalogFilter: tab1Input?.catalogType,
                }
                return from(getGasSeparatorEquipments(payload)).pipe(
                    mergeMap(data => {
                        if (data?.length === 0) {
                            return [
                                setGasNotification({
                                    show: true,
                                    message: "There are no co-related Equipments for this Gas Separator.",
                                    type: "info",
                                }),
                                setShowHideGasSeparatorEquipment(false),
                            ];
                        };
                        return [
                            setGasNotification({
                                show: false,
                                message: "",
                                type: "",
                            }),
                            setShowHideGasSeparatorEquipment(true),
                            setGasSeparatorsEquipmentDropdown(data)
                        ];
                    }),
                );
            }
            return EMPTY;
        })
    )
};

export const gasCalculationEpic = combineEpics(getTubingODList, getAnchorID, getTFVSepWarning, fetchPowerRating, gasDesignChange, getGasEffLoop1, getGasSepData, getGasEffLoop2, getGasSep2Data, getGasEffLoop3, getGasSep3Data, getGasEffLoop4, getGasSep4Data, getGKXData, getChargePump1Data, getChargePump2Data, getChargePump3Data, calculateTFVFinal, loadSeperatorList, fetchEquipmentsSeparator);
